{
  "version": 2,
  "set": "core_52",
  "pronouns": [
    "eu",
    "tu",
    "você",
    "nós",
    "eles"
  ],
  "verbs": [
    {
      "infinitive": "falar",
      "englishMeaning": "to speak",
      "verbType": "regular-ar",
      "stemChangePattern": null,
      "conjugations": {
        "present": {
          "eu": "falo",
          "tu": "falas",
          "você": "fala",
          "nós": "falamos",
          "eles": "falam"
        },
        "preterite": {
          "eu": "falei",
          "tu": "falaste",
          "você": "falou",
          "nós": "falamos",
          "eles": "falaram"
        },
        "imperfect": {
          "eu": "falava",
          "tu": "falavas",
          "você": "falava",
          "nós": "falávamos",
          "eles": "falavam"
        },
        "future": {
          "eu": "falarei",
          "tu": "falarás",
          "você": "falará",
          "nós": "falaremos",
          "eles": "falarão"
        },
        "conditional": {
          "eu": "falaria",
          "tu": "falarias",
          "você": "falaria",
          "nós": "falaríamos",
          "eles": "falariam"
        },
        "futureProgressive": {
          "eu": "estarei falando",
          "tu": "estarás falando",
          "você": "estará falando",
          "nós": "estaremos falando",
          "eles": "estarão falando"
        },
        "presentSubjunctive": {
          "eu": "fale",
          "tu": "fales",
          "você": "fale",
          "nós": "falemos",
          "eles": "falem"
        },
        "imperfectSubjunctive": {
          "eu": "falasse",
          "tu": "falasses",
          "você": "falasse",
          "nós": "falássemos",
          "eles": "falassem"
        },
        "futureSubjunctive": {
          "eu": "falar",
          "tu": "falares",
          "você": "falar",
          "nós": "falarmos",
          "eles": "falarem"
        },
        "imperativeAffirmative": {
          "tu": "fala",
          "você": "fale",
          "nós": "falemos",
          "eles": "falem"
        },
        "imperativeNegative": {
          "tu": "não fales",
          "você": "não fale",
          "nós": "não falemos",
          "eles": "não falem"
        }
      },
      "templates": [
        {
          "id": "falar-1",
          "complementType": "fixed",
          "fixedComplement": "português",
          "englishVerb": "speak",
          "englishTranslationPattern": "{pronoun} {verb} Portuguese"
        }
      ]
    },
    {
      "infinitive": "morar",
      "englishMeaning": "to live",
      "verbType": "regular-ar",
      "stemChangePattern": null,
      "conjugations": {
        "present": {
          "eu": "moro",
          "tu": "moras",
          "você": "mora",
          "nós": "moramos",
          "eles": "moram"
        },
        "preterite": {
          "eu": "morei",
          "tu": "moraste",
          "você": "morou",
          "nós": "moramos",
          "eles": "moraram"
        },
        "imperfect": {
          "eu": "morava",
          "tu": "moravas",
          "você": "morava",
          "nós": "morávamos",
          "eles": "moravam"
        },
        "future": {
          "eu": "morarei",
          "tu": "morarás",
          "você": "morará",
          "nós": "moraremos",
          "eles": "morarão"
        },
        "conditional": {
          "eu": "moraria",
          "tu": "morarias",
          "você": "moraria",
          "nós": "moraríamos",
          "eles": "morariam"
        },
        "futureProgressive": {
          "eu": "estarei morando",
          "tu": "estarás morando",
          "você": "estará morando",
          "nós": "estaremos morando",
          "eles": "estarão morando"
        },
        "presentSubjunctive": {
          "eu": "more",
          "tu": "mores",
          "você": "more",
          "nós": "moremos",
          "eles": "morem"
        },
        "imperfectSubjunctive": {
          "eu": "morasse",
          "tu": "morasses",
          "você": "morasse",
          "nós": "morássemos",
          "eles": "morassem"
        },
        "futureSubjunctive": {
          "eu": "morar",
          "tu": "morares",
          "você": "morar",
          "nós": "morarmos",
          "eles": "morarem"
        },
        "imperativeAffirmative": {
          "tu": "mora",
          "você": "more",
          "nós": "moremos",
          "eles": "morem"
        },
        "imperativeNegative": {
          "tu": "não mores",
          "você": "não more",
          "nós": "não moremos",
          "eles": "não morem"
        }
      },
      "templates": [
        {
          "id": "morar-1",
          "complementType": "fixed",
          "fixedComplement": "aqui",
          "englishVerb": "live",
          "englishTranslationPattern": "{pronoun} {verb} here",
          "allowedPhrases": [
            "time"
          ]
        }
      ]
    },
    {
      "infinitive": "estudar",
      "englishMeaning": "to study",
      "verbType": "regular-ar",
      "stemChangePattern": null,
      "conjugations": {
        "present": {
          "eu": "estudo",
          "tu": "estudas",
          "você": "estuda",
          "nós": "estudamos",
          "eles": "estudam"
        },
        "preterite": {
          "eu": "estudei",
          "tu": "estudaste",
          "você": "estudou",
          "nós": "estudamos",
          "eles": "estudaram"
        },
        "imperfect": {
          "eu": "estudava",
          "tu": "estudavas",
          "você": "estudava",
          "nós": "estudávamos",
          "eles": "estudavam"
        },
        "future": {
          "eu": "estudarei",
          "tu": "estudarás",
          "você": "estudará",
          "nós": "estudaremos",
          "eles": "estudarão"
        },
        "conditional": {
          "eu": "estudaria",
          "tu": "estudarias",
          "você": "estudaria",
          "nós": "estudaríamos",
          "eles": "estudariam"
        },
        "futureProgressive": {
          "eu": "estarei estudando",
          "tu": "estarás estudando",
          "você": "estará estudando",
          "nós": "estaremos estudando",
          "eles": "estarão estudando"
        },
        "presentSubjunctive": {
          "eu": "estude",
          "tu": "estudes",
          "você": "estude",
          "nós": "estudemos",
          "eles": "estudem"
        },
        "imperfectSubjunctive": {
          "eu": "estudasse",
          "tu": "estudasses",
          "você": "estudasse",
          "nós": "estudássemos",
          "eles": "estudassem"
        },
        "futureSubjunctive": {
          "eu": "estudar",
          "tu": "estudares",
          "você": "estudar",
          "nós": "estudarmos",
          "eles": "estudarem"
        },
        "imperativeAffirmative": {
          "tu": "estuda",
          "você": "estude",
          "nós": "estudemos",
          "eles": "estudem"
        },
        "imperativeNegative": {
          "tu": "não estudes",
          "você": "não estude",
          "nós": "não estudemos",
          "eles": "não estudem"
        }
      },
      "templates": [
        {
          "id": "estudar-1",
          "complementType": "fixed",
          "fixedComplement": "português",
          "englishVerb": "study",
          "englishTranslationPattern": "{pronoun} {verb} Portuguese"
        },
        {
          "id": "estudar-2",
          "complementType": "none",
          "fixedComplement": null,
          "englishVerb": "study",
          "englishTranslationPattern": "{pronoun} {verb}"
        }
      ]
    },
    {
      "infinitive": "trabalhar",
      "englishMeaning": "to work",
      "verbType": "regular-ar",
      "stemChangePattern": null,
      "conjugations": {
        "present": {
          "eu": "trabalho",
          "tu": "trabalhas",
          "você": "trabalha",
          "nós": "trabalhamos",
          "eles": "trabalham"
        },
        "preterite": {
          "eu": "trabalhei",
          "tu": "trabalhaste",
          "você": "trabalhou",
          "nós": "trabalhamos",
          "eles": "trabalharam"
        },
        "imperfect": {
          "eu": "trabalhava",
          "tu": "trabalhavas",
          "você": "trabalhava",
          "nós": "trabalhávamos",
          "eles": "trabalhavam"
        },
        "future": {
          "eu": "trabalharei",
          "tu": "trabalharás",
          "você": "trabalhará",
          "nós": "trabalharemos",
          "eles": "trabalharão"
        },
        "conditional": {
          "eu": "trabalharia",
          "tu": "trabalharias",
          "você": "trabalharia",
          "nós": "trabalharíamos",
          "eles": "trabalhariam"
        },
        "futureProgressive": {
          "eu": "estarei trabalhando",
          "tu": "estarás trabalhando",
          "você": "estará trabalhando",
          "nós": "estaremos trabalhando",
          "eles": "estarão trabalhando"
        },
        "presentSubjunctive": {
          "eu": "trabalhe",
          "tu": "trabalhes",
          "você": "trabalhe",
          "nós": "trabalhemos",
          "eles": "trabalhem"
        },
        "imperfectSubjunctive": {
          "eu": "trabalhasse",
          "tu": "trabalhasses",
          "você": "trabalhasse",
          "nós": "trabalhássemos",
          "eles": "trabalhassem"
        },
        "futureSubjunctive": {
          "eu": "trabalhar",
          "tu": "trabalhares",
          "você": "trabalhar",
          "nós": "trabalharmos",
          "eles": "trabalharem"
        },
        "imperativeAffirmative": {
          "tu": "trabalha",
          "você": "trabalhe",
          "nós": "trabalhemos",
          "eles": "trabalhem"
        },
        "imperativeNegative": {
          "tu": "não trabalhes",
          "você": "não trabalhe",
          "nós": "não trabalhemos",
          "eles": "não trabalhem"
        }
      },
      "templates": [
        {
          "id": "trabalhar-1",
          "complementType": "none",
          "fixedComplement": null,
          "englishVerb": "work",
          "englishTranslationPattern": "{pronoun} {verb}"
        },
        {
          "id": "trabalhar-2",
          "complementType": "fixed",
          "fixedComplement": "muito",
          "englishVerb": "work",
          "englishTranslationPattern": "{pronoun} {verb} hard"
        }
      ]
    },
    {
      "infinitive": "comprar",
      "englishMeaning": "to buy",
      "verbType": "regular-ar",
      "stemChangePattern": null,
      "conjugations": {
        "present": {
          "eu": "compro",
          "tu": "compras",
          "você": "compra",
          "nós": "compramos",
          "eles": "compram"
        },
        "preterite": {
          "eu": "comprei",
          "tu": "compraste",
          "você": "comprou",
          "nós": "compramos",
          "eles": "compraram"
        },
        "imperfect": {
          "eu": "comprava",
          "tu": "compravas",
          "você": "comprava",
          "nós": "comprávamos",
          "eles": "compravam"
        },
        "future": {
          "eu": "comprarei",
          "tu": "comprarás",
          "você": "comprará",
          "nós": "compraremos",
          "eles": "comprarão"
        },
        "conditional": {
          "eu": "compraria",
          "tu": "comprarias",
          "você": "compraria",
          "nós": "compraríamos",
          "eles": "comprariam"
        },
        "futureProgressive": {
          "eu": "estarei comprando",
          "tu": "estarás comprando",
          "você": "estará comprando",
          "nós": "estaremos comprando",
          "eles": "estarão comprando"
        },
        "presentSubjunctive": {
          "eu": "compre",
          "tu": "compres",
          "você": "compre",
          "nós": "compremos",
          "eles": "comprem"
        },
        "imperfectSubjunctive": {
          "eu": "comprasse",
          "tu": "comprasses",
          "você": "comprasse",
          "nós": "comprássemos",
          "eles": "comprassem"
        },
        "futureSubjunctive": {
          "eu": "comprar",
          "tu": "comprares",
          "você": "comprar",
          "nós": "comprarmos",
          "eles": "comprarem"
        },
        "imperativeAffirmative": {
          "tu": "compra",
          "você": "compre",
          "nós": "compremos",
          "eles": "comprem"
        },
        "imperativeNegative": {
          "tu": "não compres",
          "você": "não compre",
          "nós": "não compremos",
          "eles": "não comprem"
        }
      },
      "templates": [
        {
          "id": "comprar-1",
          "complementType": "fixed",
          "fixedComplement": "pão",
          "englishVerb": "buy",
          "englishTranslationPattern": "{pronoun} {verb} bread"
        },
        {
          "id": "comprar-2",
          "complementType": "objectSlot",
          "fixedComplement": null,
          "englishVerb": "buy",
          "englishTranslationPattern": "{pronoun} {verb} {object}"
        }
      ]
    },
    {
      "infinitive": "cozinhar",
      "englishMeaning": "to cook",
      "verbType": "regular-ar",
      "stemChangePattern": null,
      "conjugations": {
        "present": {
          "eu": "cozinho",
          "tu": "cozinhas",
          "você": "cozinha",
          "nós": "cozinhamos",
          "eles": "cozinham"
        },
        "preterite": {
          "eu": "cozinhei",
          "tu": "cozinhaste",
          "você": "cozinhou",
          "nós": "cozinhamos",
          "eles": "cozinharam"
        },
        "imperfect": {
          "eu": "cozinhava",
          "tu": "cozinhavas",
          "você": "cozinhava",
          "nós": "cozinhávamos",
          "eles": "cozinhavam"
        },
        "future": {
          "eu": "cozinharei",
          "tu": "cozinharás",
          "você": "cozinhará",
          "nós": "cozinharemos",
          "eles": "cozinharão"
        },
        "conditional": {
          "eu": "cozinharia",
          "tu": "cozinharias",
          "você": "cozinharia",
          "nós": "cozinharíamos",
          "eles": "cozinhariam"
        },
        "futureProgressive": {
          "eu": "estarei cozinhando",
          "tu": "estarás cozinhando",
          "você": "estará cozinhando",
          "nós": "estaremos cozinhando",
          "eles": "estarão cozinhando"
        },
        "presentSubjunctive": {
          "eu": "cozinhe",
          "tu": "cozinhes",
          "você": "cozinhe",
          "nós": "cozinhemos",
          "eles": "cozinhem"
        },
        "imperfectSubjunctive": {
          "eu": "cozinhasse",
          "tu": "cozinhasses",
          "você": "cozinhasse",
          "nós": "cozinhássemos",
          "eles": "cozinhassem"
        },
        "futureSubjunctive": {
          "eu": "cozinhar",
          "tu": "cozinhares",
          "você": "cozinhar",
          "nós": "cozinharmos",
          "eles": "cozinharem"
        },
        "imperativeAffirmative": {
          "tu": "cozinha",
          "você": "cozinhe",
          "nós": "cozinhemos",
          "eles": "cozinhem"
        },
        "imperativeNegative": {
          "tu": "não cozinhes",
          "você": "não cozinhe",
          "nós": "não cozinhemos",
          "eles": "não cozinhem"
        }
      },
      "templates": [
        {
          "id": "cozinhar-1",
          "complementType": "fixed",
          "fixedComplement": "o jantar",
          "englishVerb": "cook",
          "englishTranslationPattern": "{pronoun} {verb} dinner"
        },
        {
          "id": "cozinhar-2",
          "complementType": "none",
          "fixedComplement": null,
          "englishVerb": "cook",
          "englishTranslationPattern": "{pronoun} {verb}"
        }
      ]
    },
    {
      "infinitive": "dançar",
      "englishMeaning": "to dance",
      "verbType": "regular-ar",
      "stemChangePattern": null,
      "conjugations": {
        "present": {
          "eu": "danço",
          "tu": "danças",
          "você": "dança",
          "nós": "dançamos",
          "eles": "dançam"
        },
        "preterite": {
          "eu": "dancei",
          "tu": "dançaste",
          "você": "dançou",
          "nós": "dançamos",
          "eles": "dançaram"
        },
        "imperfect": {
          "eu": "dançava",
          "tu": "dançavas",
          "você": "dançava",
          "nós": "dançávamos",
          "eles": "dançavam"
        },
        "future": {
          "eu": "dançarei",
          "tu": "dançarás",
          "você": "dançará",
          "nós": "dançaremos",
          "eles": "dançarão"
        },
        "conditional": {
          "eu": "dançaria",
          "tu": "dançarias",
          "você": "dançaria",
          "nós": "dançaríamos",
          "eles": "dançariam"
        },
        "futureProgressive": {
          "eu": "estarei dançando",
          "tu": "estarás dançando",
          "você": "estará dançando",
          "nós": "estaremos dançando",
          "eles": "estarão dançando"
        },
        "presentSubjunctive": {
          "eu": "dance",
          "tu": "dances",
          "você": "dance",
          "nós": "dancemos",
          "eles": "dancem"
        },
        "imperfectSubjunctive": {
          "eu": "dançasse",
          "tu": "dançasses",
          "você": "dançasse",
          "nós": "dançássemos",
          "eles": "dançassem"
        },
        "futureSubjunctive": {
          "eu": "dançar",
          "tu": "dançares",
          "você": "dançar",
          "nós": "dançarmos",
          "eles": "dançarem"
        },
        "imperativeAffirmative": {
          "tu": "dança",
          "você": "dance",
          "nós": "dancemos",
          "eles": "dancem"
        },
        "imperativeNegative": {
          "tu": "não dances",
          "você": "não dance",
          "nós": "não dancemos",
          "eles": "não dancem"
        }
      },
      "templates": [
        {
          "id": "dançar-1",
          "complementType": "none",
          "fixedComplement": null,
          "englishVerb": "dance",
          "englishTranslationPattern": "{pronoun} {verb}"
        }
      ]
    },
    {
      "infinitive": "cantar",
      "englishMeaning": "to sing",
      "verbType": "regular-ar",
      "stemChangePattern": null,
      "conjugations": {
        "present": {
          "eu": "canto",
          "tu": "cantas",
          "você": "canta",
          "nós": "cantamos",
          "eles": "cantam"
        },
        "preterite": {
          "eu": "cantei",
          "tu": "cantaste",
          "você": "cantou",
          "nós": "cantamos",
          "eles": "cantaram"
        },
        "imperfect": {
          "eu": "cantava",
          "tu": "cantavas",
          "você": "cantava",
          "nós": "cantávamos",
          "eles": "cantavam"
        },
        "future": {
          "eu": "cantarei",
          "tu": "cantarás",
          "você": "cantará",
          "nós": "cantaremos",
          "eles": "cantarão"
        },
        "conditional": {
          "eu": "cantaria",
          "tu": "cantarias",
          "você": "cantaria",
          "nós": "cantaríamos",
          "eles": "cantariam"
        },
        "futureProgressive": {
          "eu": "estarei cantando",
          "tu": "estarás cantando",
          "você": "estará cantando",
          "nós": "estaremos cantando",
          "eles": "estarão cantando"
        },
        "presentSubjunctive": {
          "eu": "cante",
          "tu": "cantes",
          "você": "cante",
          "nós": "cantemos",
          "eles": "cantem"
        },
        "imperfectSubjunctive": {
          "eu": "cantasse",
          "tu": "cantasses",
          "você": "cantasse",
          "nós": "cantássemos",
          "eles": "cantassem"
        },
        "futureSubjunctive": {
          "eu": "cantar",
          "tu": "cantares",
          "você": "cantar",
          "nós": "cantarmos",
          "eles": "cantarem"
        },
        "imperativeAffirmative": {
          "tu": "canta",
          "você": "cante",
          "nós": "cantemos",
          "eles": "cantem"
        },
        "imperativeNegative": {
          "tu": "não cantes",
          "você": "não cante",
          "nós": "não cantemos",
          "eles": "não cantem"
        }
      },
      "templates": [
        {
          "id": "cantar-1",
          "complementType": "fixed",
          "fixedComplement": "uma música",
          "englishVerb": "sing",
          "englishTranslationPattern": "{pronoun} {verb} a song"
        },
        {
          "id": "cantar-2",
          "complementType": "none",
          "fixedComplement": null,
          "englishVerb": "sing",
          "englishTranslationPattern": "{pronoun} {verb}"
        }
      ]
    },
    {
      "infinitive": "ajudar",
      "englishMeaning": "to help",
      "verbType": "regular-ar",
      "stemChangePattern": null,
      "conjugations": {
        "present": {
          "eu": "ajudo",
          "tu": "ajudas",
          "você": "ajuda",
          "nós": "ajudamos",
          "eles": "ajudam"
        },
        "preterite": {
          "eu": "ajudei",
          "tu": "ajudaste",
          "você": "ajudou",
          "nós": "ajudamos",
          "eles": "ajudaram"
        },
        "imperfect": {
          "eu": "ajudava",
          "tu": "ajudavas",
          "você": "ajudava",
          "nós": "ajudávamos",
          "eles": "ajudavam"
        },
        "future": {
          "eu": "ajudarei",
          "tu": "ajudarás",
          "você": "ajudará",
          "nós": "ajudaremos",
          "eles": "ajudarão"
        },
        "conditional": {
          "eu": "ajudaria",
          "tu": "ajudarias",
          "você": "ajudaria",
          "nós": "ajudaríamos",
          "eles": "ajudariam"
        },
        "futureProgressive": {
          "eu": "estarei ajudando",
          "tu": "estarás ajudando",
          "você": "estará ajudando",
          "nós": "estaremos ajudando",
          "eles": "estarão ajudando"
        },
        "presentSubjunctive": {
          "eu": "ajude",
          "tu": "ajudes",
          "você": "ajude",
          "nós": "ajudemos",
          "eles": "ajudem"
        },
        "imperfectSubjunctive": {
          "eu": "ajudasse",
          "tu": "ajudasses",
          "você": "ajudasse",
          "nós": "ajudássemos",
          "eles": "ajudassem"
        },
        "futureSubjunctive": {
          "eu": "ajudar",
          "tu": "ajudares",
          "você": "ajudar",
          "nós": "ajudarmos",
          "eles": "ajudarem"
        },
        "imperativeAffirmative": {
          "tu": "ajuda",
          "você": "ajude",
          "nós": "ajudemos",
          "eles": "ajudem"
        },
        "imperativeNegative": {
          "tu": "não ajudes",
          "você": "não ajude",
          "nós": "não ajudemos",
          "eles": "não ajudem"
        }
      },
      "templates": [
        {
          "id": "ajudar-1",
          "complementType": "fixed",
          "fixedComplement": "a professora",
          "englishVerb": "help",
          "englishTranslationPattern": "{pronoun} {verb} the teacher"
        },
        {
          "id": "ajudar-2",
          "complementType": "objectSlot",
          "fixedComplement": null,
          "englishVerb": "help",
          "englishTranslationPattern": "{pronoun} {verb} {object}"
        }
      ]
    },
    {
      "infinitive": "jogar",
      "englishMeaning": "to play",
      "verbType": "regular-ar",
      "stemChangePattern": null,
      "conjugations": {
        "present": {
          "eu": "jogo",
          "tu": "jogas",
          "você": "joga",
          "nós": "jogamos",
          "eles": "jogam"
        },
        "preterite": {
          "eu": "joguei",
          "tu": "jogaste",
          "você": "jogou",
          "nós": "jogamos",
          "eles": "jogaram"
        },
        "imperfect": {
          "eu": "jogava",
          "tu": "jogavas",
          "você": "jogava",
          "nós": "jogávamos",
          "eles": "jogavam"
        },
        "future": {
          "eu": "jogarei",
          "tu": "jogarás",
          "você": "jogará",
          "nós": "jogaremos",
          "eles": "jogarão"
        },
        "conditional": {
          "eu": "jogaria",
          "tu": "jogarias",
          "você": "jogaria",
          "nós": "jogaríamos",
          "eles": "jogariam"
        },
        "futureProgressive": {
          "eu": "estarei jogando",
          "tu": "estarás jogando",
          "você": "estará jogando",
          "nós": "estaremos jogando",
          "eles": "estarão jogando"
        },
        "presentSubjunctive": {
          "eu": "jogue",
          "tu": "jogues",
          "você": "jogue",
          "nós": "joguemos",
          "eles": "joguem"
        },
        "imperfectSubjunctive": {
          "eu": "jogasse",
          "tu": "jogasses",
          "você": "jogasse",
          "nós": "jogássemos",
          "eles": "jogassem"
        },
        "futureSubjunctive": {
          "eu": "jogar",
          "tu": "jogares",
          "você": "jogar",
          "nós": "jogarmos",
          "eles": "jogarem"
        },
        "imperativeAffirmative": {
          "tu": "joga",
          "você": "jogue",
          "nós": "joguemos",
          "eles": "joguem"
        },
        "imperativeNegative": {
          "tu": "não jogues",
          "você": "não jogue",
          "nós": "não joguemos",
          "eles": "não joguem"
        }
      },
      "templates": [
        {
          "id": "jogar-1",
          "complementType": "fixed",
          "fixedComplement": "futebol",
          "englishVerb": "play",
          "englishTranslationPattern": "{pronoun} {verb} soccer"
        },
        {
          "id": "jogar-2",
          "complementType": "none",
          "fixedComplement": null,
          "englishVerb": "play",
          "englishTranslationPattern": "{pronoun} {verb}"
        }
      ]
    },
    {
      "infinitive": "viajar",
      "englishMeaning": "to travel",
      "verbType": "regular-ar",
      "stemChangePattern": null,
      "conjugations": {
        "present": {
          "eu": "viajo",
          "tu": "viajas",
          "você": "viaja",
          "nós": "viajamos",
          "eles": "viajam"
        },
        "preterite": {
          "eu": "viajei",
          "tu": "viajaste",
          "você": "viajou",
          "nós": "viajamos",
          "eles": "viajaram"
        },
        "imperfect": {
          "eu": "viajava",
          "tu": "viajavas",
          "você": "viajava",
          "nós": "viajávamos",
          "eles": "viajavam"
        },
        "future": {
          "eu": "viajarei",
          "tu": "viajarás",
          "você": "viajará",
          "nós": "viajaremos",
          "eles": "viajarão"
        },
        "conditional": {
          "eu": "viajaria",
          "tu": "viajarias",
          "você": "viajaria",
          "nós": "viajaríamos",
          "eles": "viajariam"
        },
        "futureProgressive": {
          "eu": "estarei viajando",
          "tu": "estarás viajando",
          "você": "estará viajando",
          "nós": "estaremos viajando",
          "eles": "estarão viajando"
        },
        "presentSubjunctive": {
          "eu": "viaje",
          "tu": "viajes",
          "você": "viaje",
          "nós": "viajemos",
          "eles": "viajem"
        },
        "imperfectSubjunctive": {
          "eu": "viajasse",
          "tu": "viajasses",
          "você": "viajasse",
          "nós": "viajássemos",
          "eles": "viajassem"
        },
        "futureSubjunctive": {
          "eu": "viajar",
          "tu": "viajares",
          "você": "viajar",
          "nós": "viajarmos",
          "eles": "viajarem"
        },
        "imperativeAffirmative": {
          "tu": "viaja",
          "você": "viaje",
          "nós": "viajemos",
          "eles": "viajem"
        },
        "imperativeNegative": {
          "tu": "não viajes",
          "você": "não viaje",
          "nós": "não viajemos",
          "eles": "não viajem"
        }
      },
      "templates": [
        {
          "id": "viajar-1",
          "complementType": "none",
          "fixedComplement": null,
          "englishVerb": "travel",
          "englishTranslationPattern": "{pronoun} {verb}",
          "allowedPhrases": [
            "time",
            "manner"
          ]
        }
      ]
    },
    {
      "infinitive": "esperar",
      "englishMeaning": "to wait",
      "verbType": "regular-ar",
      "stemChangePattern": null,
      "conjugations": {
        "present": {
          "eu": "espero",
          "tu": "esperas",
          "você": "espera",
          "nós": "esperamos",
          "eles": "esperam"
        },
        "preterite": {
          "eu": "esperei",
          "tu": "esperaste",
          "você": "esperou",
          "nós": "esperamos",
          "eles": "esperaram"
        },
        "imperfect": {
          "eu": "esperava",
          "tu": "esperavas",
          "você": "esperava",
          "nós": "esperávamos",
          "eles": "esperavam"
        },
        "future": {
          "eu": "esperarei",
          "tu": "esperarás",
          "você": "esperará",
          "nós": "esperaremos",
          "eles": "esperarão"
        },
        "conditional": {
          "eu": "esperaria",
          "tu": "esperarias",
          "você": "esperaria",
          "nós": "esperaríamos",
          "eles": "esperariam"
        },
        "futureProgressive": {
          "eu": "estarei esperando",
          "tu": "estarás esperando",
          "você": "estará esperando",
          "nós": "estaremos esperando",
          "eles": "estarão esperando"
        },
        "presentSubjunctive": {
          "eu": "espere",
          "tu": "esperes",
          "você": "espere",
          "nós": "esperemos",
          "eles": "esperem"
        },
        "imperfectSubjunctive": {
          "eu": "esperasse",
          "tu": "esperasses",
          "você": "esperasse",
          "nós": "esperássemos",
          "eles": "esperassem"
        },
        "futureSubjunctive": {
          "eu": "esperar",
          "tu": "esperares",
          "você": "esperar",
          "nós": "esperarmos",
          "eles": "esperarem"
        },
        "imperativeAffirmative": {
          "tu": "espera",
          "você": "espere",
          "nós": "esperemos",
          "eles": "esperem"
        },
        "imperativeNegative": {
          "tu": "não esperes",
          "você": "não espere",
          "nós": "não esperemos",
          "eles": "não esperem"
        }
      },
      "templates": [
        {
          "id": "esperar-1",
          "complementType": "fixed",
          "fixedComplement": "o ônibus",
          "englishVerb": "wait",
          "englishTranslationPattern": "{pronoun} {verb} for the bus"
        },
        {
          "id": "esperar-2",
          "complementType": "none",
          "fixedComplement": null,
          "englishVerb": "wait",
          "englishTranslationPattern": "{pronoun} {verb}"
        }
      ]
    },
    {
      "infinitive": "chegar",
      "englishMeaning": "to arrive",
      "verbType": "regular-ar",
      "stemChangePattern": null,
      "conjugations": {
        "present": {
          "eu": "chego",
          "tu": "chegas",
          "você": "chega",
          "nós": "chegamos",
          "eles": "chegam"
        },
        "preterite": {
          "eu": "cheguei",
          "tu": "chegaste",
          "você": "chegou",
          "nós": "chegamos",
          "eles": "chegaram"
        },
        "imperfect": {
          "eu": "chegava",
          "tu": "chegavas",
          "você": "chegava",
          "nós": "chegávamos",
          "eles": "chegavam"
        },
        "future": {
          "eu": "chegarei",
          "tu": "chegarás",
          "você": "chegará",
          "nós": "chegaremos",
          "eles": "chegarão"
        },
        "conditional": {
          "eu": "chegaria",
          "tu": "chegarias",
          "você": "chegaria",
          "nós": "chegaríamos",
          "eles": "chegariam"
        },
        "futureProgressive": {
          "eu": "estarei chegando",
          "tu": "estarás chegando",
          "você": "estará chegando",
          "nós": "estaremos chegando",
          "eles": "estarão chegando"
        },
        "presentSubjunctive": {
          "eu": "chegue",
          "tu": "chegues",
          "você": "chegue",
          "nós": "cheguemos",
          "eles": "cheguem"
        },
        "imperfectSubjunctive": {
          "eu": "chegasse",
          "tu": "chegasses",
          "você": "chegasse",
          "nós": "chegássemos",
          "eles": "chegassem"
        },
        "futureSubjunctive": {
          "eu": "chegar",
          "tu": "chegares",
          "você": "chegar",
          "nós": "chegarmos",
          "eles": "chegarem"
        },
        "imperativeAffirmative": {
          "tu": "chega",
          "você": "chegue",
          "nós": "cheguemos",
          "eles": "cheguem"
        },
        "imperativeNegative": {
          "tu": "não chegues",
          "você": "não chegue",
          "nós": "não cheguemos",
          "eles": "não cheguem"
        }
      },
      "templates": [
        {
          "id": "chegar-1",
          "complementType": "none",
          "fixedComplement": null,
          "englishVerb": "arrive",
          "englishTranslationPattern": "{pronoun} {verb}"
        }
      ]
    },
    {
      "infinitive": "andar",
      "englishMeaning": "to walk",
      "verbType": "regular-ar",
      "stemChangePattern": null,
      "conjugations": {
        "present": {
          "eu": "ando",
          "tu": "andas",
          "você": "anda",
          "nós": "andamos",
          "eles": "andam"
        },
        "preterite": {
          "eu": "andei",
          "tu": "andaste",
          "você": "andou",
          "nós": "andamos",
          "eles": "andaram"
        },
        "imperfect": {
          "eu": "andava",
          "tu": "andavas",
          "você": "andava",
          "nós": "andávamos",
          "eles": "andavam"
        },
        "future": {
          "eu": "andarei",
          "tu": "andarás",
          "você": "andará",
          "nós": "andaremos",
          "eles": "andarão"
        },
        "conditional": {
          "eu": "andaria",
          "tu": "andarias",
          "você": "andaria",
          "nós": "andaríamos",
          "eles": "andariam"
        },
        "futureProgressive": {
          "eu": "estarei andando",
          "tu": "estarás andando",
          "você": "estará andando",
          "nós": "estaremos andando",
          "eles": "estarão andando"
        },
        "presentSubjunctive": {
          "eu": "ande",
          "tu": "andes",
          "você": "ande",
          "nós": "andemos",
          "eles": "andem"
        },
        "imperfectSubjunctive": {
          "eu": "andasse",
          "tu": "andasses",
          "você": "andasse",
          "nós": "andássemos",
          "eles": "andassem"
        },
        "futureSubjunctive": {
          "eu": "andar",
          "tu": "andares",
          "você": "andar",
          "nós": "andarmos",
          "eles": "andarem"
        },
        "imperativeAffirmative": {
          "tu": "anda",
          "você": "ande",
          "nós": "andemos",
          "eles": "andem"
        },
        "imperativeNegative": {
          "tu": "não andes",
          "você": "não ande",
          "nós": "não andemos",
          "eles": "não andem"
        }
      },
      "templates": [
        {
          "id": "andar-1",
          "complementType": "none",
          "fixedComplement": null,
          "englishVerb": "walk",
          "englishTranslationPattern": "{pronoun} {verb}"
        }
      ]
    },
    {
      "infinitive": "comer",
      "englishMeaning": "to eat",
      "verbType": "regular-er",
      "stemChangePattern": null,
      "conjugations": {
        "present": {
          "eu": "como",
          "tu": "comes",
          "você": "come",
          "nós": "comemos",
          "eles": "comem"
        },
        "preterite": {
          "eu": "comi",
          "tu": "comeste",
          "você": "comeu",
          "nós": "comemos",
          "eles": "comeram"
        },
        "imperfect": {
          "eu": "comia",
          "tu": "comias",
          "você": "comia",
          "nós": "comíamos",
          "eles": "comiam"
        },
        "future": {
          "eu": "comerei",
          "tu": "comerás",
          "você": "comerá",
          "nós": "comeremos",
          "eles": "comerão"
        },
        "conditional": {
          "eu": "comeria",
          "tu": "comerias",
          "você": "comeria",
          "nós": "comeríamos",
          "eles": "comeriam"
        },
        "futureProgressive": {
          "eu": "estarei comendo",
          "tu": "estarás comendo",
          "você": "estará comendo",
          "nós": "estaremos comendo",
          "eles": "estarão comendo"
        },
        "presentSubjunctive": {
          "eu": "coma",
          "tu": "comas",
          "você": "coma",
          "nós": "comamos",
          "eles": "comam"
        },
        "imperfectSubjunctive": {
          "eu": "comesse",
          "tu": "comesses",
          "você": "comesse",
          "nós": "comêssemos",
          "eles": "comessem"
        },
        "futureSubjunctive": {
          "eu": "comer",
          "tu": "comeres",
          "você": "comer",
          "nós": "comermos",
          "eles": "comerem"
        },
        "imperativeAffirmative": {
          "tu": "come",
          "você": "coma",
          "nós": "comamos",
          "eles": "comam"
        },
        "imperativeNegative": {
          "tu": "não comas",
          "você": "não coma",
          "nós": "não comamos",
          "eles": "não comam"
        }
      },
      "templates": [
        {
          "id": "comer-1",
          "complementType": "fixed",
          "fixedComplement": "pizza",
          "englishVerb": "eat",
          "englishTranslationPattern": "{pronoun} {verb} pizza"
        },
        {
          "id": "comer-2",
          "complementType": "objectSlot",
          "fixedComplement": null,
          "englishVerb": "eat",
          "englishTranslationPattern": "{pronoun} {verb} {object}"
        }
      ]
    },
    {
      "infinitive": "beber",
      "englishMeaning": "to drink",
      "verbType": "regular-er",
      "stemChangePattern": null,
      "conjugations": {
        "present": {
          "eu": "bebo",
          "tu": "bebes",
          "você": "bebe",
          "nós": "bebemos",
          "eles": "bebem"
        },
        "preterite": {
          "eu": "bebi",
          "tu": "bebeste",
          "você": "bebeu",
          "nós": "bebemos",
          "eles": "beberam"
        },
        "imperfect": {
          "eu": "bebia",
          "tu": "bebias",
          "você": "bebia",
          "nós": "bebíamos",
          "eles": "bebiam"
        },
        "future": {
          "eu": "beberei",
          "tu": "beberás",
          "você": "beberá",
          "nós": "beberemos",
          "eles": "beberão"
        },
        "conditional": {
          "eu": "beberia",
          "tu": "beberias",
          "você": "beberia",
          "nós": "beberíamos",
          "eles": "beberiam"
        },
        "futureProgressive": {
          "eu": "estarei bebendo",
          "tu": "estarás bebendo",
          "você": "estará bebendo",
          "nós": "estaremos bebendo",
          "eles": "estarão bebendo"
        },
        "presentSubjunctive": {
          "eu": "beba",
          "tu": "bebas",
          "você": "beba",
          "nós": "bebamos",
          "eles": "bebam"
        },
        "imperfectSubjunctive": {
          "eu": "bebesse",
          "tu": "bebesses",
          "você": "bebesse",
          "nós": "bebêssemos",
          "eles": "bebessem"
        },
        "futureSubjunctive": {
          "eu": "beber",
          "tu": "beberes",
          "você": "beber",
          "nós": "bebermos",
          "eles": "beberem"
        },
        "imperativeAffirmative": {
          "tu": "bebe",
          "você": "beba",
          "nós": "bebamos",
          "eles": "bebam"
        },
        "imperativeNegative": {
          "tu": "não bebas",
          "você": "não beba",
          "nós": "não bebamos",
          "eles": "não bebam"
        }
      },
      "templates": [
        {
          "id": "beber-1",
          "complementType": "fixed",
          "fixedComplement": "água",
          "englishVerb": "drink",
          "englishTranslationPattern": "{pronoun} {verb} water"
        },
        {
          "id": "beber-2",
          "complementType": "objectSlot",
          "fixedComplement": null,
          "englishVerb": "drink",
          "englishTranslationPattern": "{pronoun} {verb} {object}"
        }
      ]
    },
    {
      "infinitive": "aprender",
      "englishMeaning": "to learn",
      "verbType": "regular-er",
      "stemChangePattern": null,
      "conjugations": {
        "present": {
          "eu": "aprendo",
          "tu": "aprendes",
          "você": "aprende",
          "nós": "aprendemos",
          "eles": "aprendem"
        },
        "preterite": {
          "eu": "aprendi",
          "tu": "aprendeste",
          "você": "aprendeu",
          "nós": "aprendemos",
          "eles": "aprenderam"
        },
        "imperfect": {
          "eu": "aprendia",
          "tu": "aprendias",
          "você": "aprendia",
          "nós": "aprendíamos",
          "eles": "aprendiam"
        },
        "future": {
          "eu": "aprenderei",
          "tu": "aprenderás",
          "você": "aprenderá",
          "nós": "aprenderemos",
          "eles": "aprenderão"
        },
        "conditional": {
          "eu": "aprenderia",
          "tu": "aprenderias",
          "você": "aprenderia",
          "nós": "aprenderíamos",
          "eles": "aprenderiam"
        },
        "futureProgressive": {
          "eu": "estarei aprendendo",
          "tu": "estarás aprendendo",
          "você": "estará aprendendo",
          "nós": "estaremos aprendendo",
          "eles": "estarão aprendendo"
        },
        "presentSubjunctive": {
          "eu": "aprenda",
          "tu": "aprendas",
          "você": "aprenda",
          "nós": "aprendamos",
          "eles": "aprendam"
        },
        "imperfectSubjunctive": {
          "eu": "aprendesse",
          "tu": "aprendesses",
          "você": "aprendesse",
          "nós": "aprendêssemos",
          "eles": "aprendessem"
        },
        "futureSubjunctive": {
          "eu": "aprender",
          "tu": "aprenderes",
          "você": "aprender",
          "nós": "aprendermos",
          "eles": "aprenderem"
        },
        "imperativeAffirmative": {
          "tu": "aprende",
          "você": "aprenda",
          "nós": "aprendamos",
          "eles": "aprendam"
        },
        "imperativeNegative": {
          "tu": "não aprendas",
          "você": "não aprenda",
          "nós": "não aprendamos",
          "eles": "não aprendam"
        }
      },
      "templates": [
        {
          "id": "aprender-1",
          "complementType": "fixed",
          "fixedComplement": "português",
          "englishVerb": "learn",
          "englishTranslationPattern": "{pronoun} {verb} Portuguese"
        },
        {
          "id": "aprender-2",
          "complementType": "objectSlot",
          "fixedComplement": null,
          "englishVerb": "learn",
          "englishTranslationPattern": "{pronoun} {verb} {object}"
        }
      ]
    },
    {
      "infinitive": "vender",
      "englishMeaning": "to sell",
      "verbType": "regular-er",
      "stemChangePattern": null,
      "conjugations": {
        "present": {
          "eu": "vendo",
          "tu": "vendes",
          "você": "vende",
          "nós": "vendemos",
          "eles": "vendem"
        },
        "preterite": {
          "eu": "vendi",
          "tu": "vendeste",
          "você": "vendeu",
          "nós": "vendemos",
          "eles": "venderam"
        },
        "imperfect": {
          "eu": "vendia",
          "tu": "vendias",
          "você": "vendia",
          "nós": "vendíamos",
          "eles": "vendiam"
        },
        "future": {
          "eu": "venderei",
          "tu": "venderás",
          "você": "venderá",
          "nós": "venderemos",
          "eles": "venderão"
        },
        "conditional": {
          "eu": "venderia",
          "tu": "venderias",
          "você": "venderia",
          "nós": "venderíamos",
          "eles": "venderiam"
        },
        "futureProgressive": {
          "eu": "estarei vendendo",
          "tu": "estarás vendendo",
          "você": "estará vendendo",
          "nós": "estaremos vendendo",
          "eles": "estarão vendendo"
        },
        "presentSubjunctive": {
          "eu": "venda",
          "tu": "vendas",
          "você": "venda",
          "nós": "vendamos",
          "eles": "vendam"
        },
        "imperfectSubjunctive": {
          "eu": "vendesse",
          "tu": "vendesses",
          "você": "vendesse",
          "nós": "vendêssemos",
          "eles": "vendessem"
        },
        "futureSubjunctive": {
          "eu": "vender",
          "tu": "venderes",
          "você": "vender",
          "nós": "vendermos",
          "eles": "venderem"
        },
        "imperativeAffirmative": {
          "tu": "vende",
          "você": "venda",
          "nós": "vendamos",
          "eles": "vendam"
        },
        "imperativeNegative": {
          "tu": "não vendas",
          "você": "não venda",
          "nós": "não vendamos",
          "eles": "não vendam"
        }
      },
      "templates": [
        {
          "id": "vender-1",
          "complementType": "fixed",
          "fixedComplement": "a casa",
          "englishVerb": "sell",
          "englishTranslationPattern": "{pronoun} {verb} the house"
        },
        {
          "id": "vender-2",
          "complementType": "objectSlot",
          "fixedComplement": null,
          "englishVerb": "sell",
          "englishTranslationPattern": "{pronoun} {verb} {object}"
        }
      ]
    },
    {
      "infinitive": "correr",
      "englishMeaning": "to run",
      "verbType": "regular-er",
      "stemChangePattern": null,
      "conjugations": {
        "present": {
          "eu": "corro",
          "tu": "corres",
          "você": "corre",
          "nós": "corremos",
          "eles": "correm"
        },
        "preterite": {
          "eu": "corri",
          "tu": "correste",
          "você": "correu",
          "nós": "corremos",
          "eles": "correram"
        },
        "imperfect": {
          "eu": "corria",
          "tu": "corrias",
          "você": "corria",
          "nós": "corríamos",
          "eles": "corriam"
        },
        "future": {
          "eu": "correrei",
          "tu": "correrás",
          "você": "correrá",
          "nós": "correremos",
          "eles": "correrão"
        },
        "conditional": {
          "eu": "correria",
          "tu": "correrias",
          "você": "correria",
          "nós": "correríamos",
          "eles": "correriam"
        },
        "futureProgressive": {
          "eu": "estarei correndo",
          "tu": "estarás correndo",
          "você": "estará correndo",
          "nós": "estaremos correndo",
          "eles": "estarão correndo"
        },
        "presentSubjunctive": {
          "eu": "corra",
          "tu": "corras",
          "você": "corra",
          "nós": "corramos",
          "eles": "corram"
        },
        "imperfectSubjunctive": {
          "eu": "corresse",
          "tu": "corresses",
          "você": "corresse",
          "nós": "corrêssemos",
          "eles": "corressem"
        },
        "futureSubjunctive": {
          "eu": "correr",
          "tu": "correres",
          "você": "correr",
          "nós": "corrermos",
          "eles": "correrem"
        },
        "imperativeAffirmative": {
          "tu": "corre",
          "você": "corra",
          "nós": "corramos",
          "eles": "corram"
        },
        "imperativeNegative": {
          "tu": "não corras",
          "você": "não corra",
          "nós": "não corramos",
          "eles": "não corram"
        }
      },
      "templates": [
        {
          "id": "correr-1",
          "complementType": "none",
          "fixedComplement": null,
          "englishVerb": "run",
          "englishTranslationPattern": "{pronoun} {verb}"
        }
      ]
    },
    {
      "infinitive": "escrever",
      "englishMeaning": "to write",
      "verbType": "regular-er",
      "stemChangePattern": null,
      "conjugations": {
        "present": {
          "eu": "escrevo",
          "tu": "escreves",
          "você": "escreve",
          "nós": "escrevemos",
          "eles": "escrevem"
        },
        "preterite": {
          "eu": "escrevi",
          "tu": "escreveste",
          "você": "escreveu",
          "nós": "escrevemos",
          "eles": "escreveram"
        },
        "imperfect": {
          "eu": "escrevia",
          "tu": "escrevias",
          "você": "escrevia",
          "nós": "escrevíamos",
          "eles": "escreviam"
        },
        "future": {
          "eu": "escreverei",
          "tu": "escreverás",
          "você": "escreverá",
          "nós": "escreveremos",
          "eles": "escreverão"
        },
        "conditional": {
          "eu": "escreveria",
          "tu": "escreverias",
          "você": "escreveria",
          "nós": "escreveríamos",
          "eles": "escreveriam"
        },
        "futureProgressive": {
          "eu": "estarei escrevendo",
          "tu": "estarás escrevendo",
          "você": "estará escrevendo",
          "nós": "estaremos escrevendo",
          "eles": "estarão escrevendo"
        },
        "presentSubjunctive": {
          "eu": "escreva",
          "tu": "escrevas",
          "você": "escreva",
          "nós": "escrevamos",
          "eles": "escrevam"
        },
        "imperfectSubjunctive": {
          "eu": "escrevesse",
          "tu": "escrevesses",
          "você": "escrevesse",
          "nós": "escrevêssemos",
          "eles": "escrevessem"
        },
        "futureSubjunctive": {
          "eu": "escrever",
          "tu": "escreveres",
          "você": "escrever",
          "nós": "escrevermos",
          "eles": "escreverem"
        },
        "imperativeAffirmative": {
          "tu": "escreve",
          "você": "escreva",
          "nós": "escrevamos",
          "eles": "escrevam"
        },
        "imperativeNegative": {
          "tu": "não escrevas",
          "você": "não escreva",
          "nós": "não escrevamos",
          "eles": "não escrevam"
        }
      },
      "templates": [
        {
          "id": "escrever-1",
          "complementType": "fixed",
          "fixedComplement": "uma carta",
          "englishVerb": "write",
          "englishTranslationPattern": "{pronoun} {verb} a letter"
        },
        {
          "id": "escrever-2",
          "complementType": "objectSlot",
          "fixedComplement": null,
          "englishVerb": "write",
          "englishTranslationPattern": "{pronoun} {verb} {object}"
        }
      ]
    },
    {
      "infinitive": "compreender",
      "englishMeaning": "to understand",
      "verbType": "regular-er",
      "stemChangePattern": null,
      "conjugations": {
        "present": {
          "eu": "compreendo",
          "tu": "compreendes",
          "você": "compreende",
          "nós": "compreendemos",
          "eles": "compreendem"
        },
        "preterite": {
          "eu": "compreendi",
          "tu": "compreendeste",
          "você": "compreendeu",
          "nós": "compreendemos",
          "eles": "compreenderam"
        },
        "imperfect": {
          "eu": "compreendia",
          "tu": "compreendias",
          "você": "compreendia",
          "nós": "compreendíamos",
          "eles": "compreendiam"
        },
        "future": {
          "eu": "compreenderei",
          "tu": "compreenderás",
          "você": "compreenderá",
          "nós": "compreenderemos",
          "eles": "compreenderão"
        },
        "conditional": {
          "eu": "compreenderia",
          "tu": "compreenderias",
          "você": "compreenderia",
          "nós": "compreenderíamos",
          "eles": "compreenderiam"
        },
        "futureProgressive": {
          "eu": "estarei compreendendo",
          "tu": "estarás compreendendo",
          "você": "estará compreendendo",
          "nós": "estaremos compreendendo",
          "eles": "estarão compreendendo"
        },
        "presentSubjunctive": {
          "eu": "compreenda",
          "tu": "compreendas",
          "você": "compreenda",
          "nós": "compreendamos",
          "eles": "compreendam"
        },
        "imperfectSubjunctive": {
          "eu": "compreendesse",
          "tu": "compreendesses",
          "você": "compreendesse",
          "nós": "compreendêssemos",
          "eles": "compreendessem"
        },
        "futureSubjunctive": {
          "eu": "compreender",
          "tu": "compreenderes",
          "você": "compreender",
          "nós": "compreendermos",
          "eles": "compreenderem"
        },
        "imperativeAffirmative": {
          "tu": "compreende",
          "você": "compreenda",
          "nós": "compreendamos",
          "eles": "compreendam"
        },
        "imperativeNegative": {
          "tu": "não compreendas",
          "você": "não compreenda",
          "nós": "não compreendamos",
          "eles": "não compreendam"
        }
      },
      "templates": [
        {
          "id": "compreender-1",
          "complementType": "fixed",
          "fixedComplement": "a lição",
          "englishVerb": "understand",
          "englishTranslationPattern": "{pronoun} {verb} the lesson"
        },
        {
          "id": "compreender-2",
          "complementType": "objectSlot",
          "fixedComplement": null,
          "englishVerb": "understand",
          "englishTranslationPattern": "{pronoun} {verb} {object}"
        }
      ]
    },
    {
      "infinitive": "meter",
      "englishMeaning": "to put",
      "verbType": "regular-er",
      "stemChangePattern": null,
      "conjugations": {
        "present": {
          "eu": "meto",
          "tu": "metes",
          "você": "mete",
          "nós": "metemos",
          "eles": "metem"
        },
        "preterite": {
          "eu": "meti",
          "tu": "meteste",
          "você": "meteu",
          "nós": "metemos",
          "eles": "meteram"
        },
        "imperfect": {
          "eu": "metia",
          "tu": "metias",
          "você": "metia",
          "nós": "metíamos",
          "eles": "metiam"
        },
        "future": {
          "eu": "meterei",
          "tu": "meterás",
          "você": "meterá",
          "nós": "meteremos",
          "eles": "meterão"
        },
        "conditional": {
          "eu": "meteria",
          "tu": "meterias",
          "você": "meteria",
          "nós": "meteríamos",
          "eles": "meteriam"
        },
        "futureProgressive": {
          "eu": "estarei metendo",
          "tu": "estarás metendo",
          "você": "estará metendo",
          "nós": "estaremos metendo",
          "eles": "estarão metendo"
        },
        "presentSubjunctive": {
          "eu": "meta",
          "tu": "metas",
          "você": "meta",
          "nós": "metamos",
          "eles": "metam"
        },
        "imperfectSubjunctive": {
          "eu": "metesse",
          "tu": "metesses",
          "você": "metesse",
          "nós": "metêssemos",
          "eles": "metessem"
        },
        "futureSubjunctive": {
          "eu": "meter",
          "tu": "meteres",
          "você": "meter",
          "nós": "metermos",
          "eles": "meterem"
        },
        "imperativeAffirmative": {
          "tu": "mete",
          "você": "meta",
          "nós": "metamos",
          "eles": "metam"
        },
        "imperativeNegative": {
          "tu": "não metas",
          "você": "não meta",
          "nós": "não metamos",
          "eles": "não metam"
        }
      },
      "templates": [
        {
          "id": "meter-1",
          "complementType": "fixed",
          "fixedComplement": "a chave no bolso",
          "englishVerb": "put",
          "englishTranslationPattern": "{pronoun} {verb} the key in the pocket",
          "allowedPhrases": [
            "time",
            "manner"
          ]
        }
      ]
    },
    {
      "infinitive": "abrir",
      "englishMeaning": "to open",
      "verbType": "regular-ir",
      "stemChangePattern": null,
      "conjugations": {
        "present": {
          "eu": "abro",
          "tu": "abres",
          "você": "abre",
          "nós": "abrimos",
          "eles": "abrem"
        },
        "preterite": {
          "eu": "abri",
          "tu": "abriste",
          "você": "abriu",
          "nós": "abrimos",
          "eles": "abriram"
        },
        "imperfect": {
          "eu": "abria",
          "tu": "abrias",
          "você": "abria",
          "nós": "abríamos",
          "eles": "abriam"
        },
        "future": {
          "eu": "abrirei",
          "tu": "abrirás",
          "você": "abrirá",
          "nós": "abriremos",
          "eles": "abrirão"
        },
        "conditional": {
          "eu": "abriria",
          "tu": "abririas",
          "você": "abriria",
          "nós": "abriríamos",
          "eles": "abririam"
        },
        "futureProgressive": {
          "eu": "estarei abrindo",
          "tu": "estarás abrindo",
          "você": "estará abrindo",
          "nós": "estaremos abrindo",
          "eles": "estarão abrindo"
        },
        "presentSubjunctive": {
          "eu": "abra",
          "tu": "abras",
          "você": "abra",
          "nós": "abramos",
          "eles": "abram"
        },
        "imperfectSubjunctive": {
          "eu": "abrisse",
          "tu": "abrisses",
          "você": "abrisse",
          "nós": "abríssemos",
          "eles": "abrissem"
        },
        "futureSubjunctive": {
          "eu": "abrir",
          "tu": "abrires",
          "você": "abrir",
          "nós": "abrirmos",
          "eles": "abrirem"
        },
        "imperativeAffirmative": {
          "tu": "abre",
          "você": "abra",
          "nós": "abramos",
          "eles": "abram"
        },
        "imperativeNegative": {
          "tu": "não abras",
          "você": "não abra",
          "nós": "não abramos",
          "eles": "não abram"
        }
      },
      "templates": [
        {
          "id": "abrir-1",
          "complementType": "fixed",
          "fixedComplement": "a porta",
          "englishVerb": "open",
          "englishTranslationPattern": "{pronoun} {verb} the door"
        },
        {
          "id": "abrir-2",
          "complementType": "objectSlot",
          "fixedComplement": null,
          "englishVerb": "open",
          "englishTranslationPattern": "{pronoun} {verb} {object}"
        }
      ]
    },
    {
      "infinitive": "decidir",
      "englishMeaning": "to decide",
      "verbType": "regular-ir",
      "stemChangePattern": null,
      "conjugations": {
        "present": {
          "eu": "decido",
          "tu": "decides",
          "você": "decide",
          "nós": "decidimos",
          "eles": "decidem"
        },
        "preterite": {
          "eu": "decidi",
          "tu": "decidiste",
          "você": "decidiu",
          "nós": "decidimos",
          "eles": "decidiram"
        },
        "imperfect": {
          "eu": "decidia",
          "tu": "decidias",
          "você": "decidia",
          "nós": "decidíamos",
          "eles": "decidiam"
        },
        "future": {
          "eu": "decidirei",
          "tu": "decidirás",
          "você": "decidirá",
          "nós": "decidiremos",
          "eles": "decidirão"
        },
        "conditional": {
          "eu": "decidiria",
          "tu": "decidirias",
          "você": "decidiria",
          "nós": "decidiríamos",
          "eles": "decidiriam"
        },
        "futureProgressive": {
          "eu": "estarei decidindo",
          "tu": "estarás decidindo",
          "você": "estará decidindo",
          "nós": "estaremos decidindo",
          "eles": "estarão decidindo"
        },
        "presentSubjunctive": {
          "eu": "decida",
          "tu": "decidas",
          "você": "decida",
          "nós": "decidamos",
          "eles": "decidam"
        },
        "imperfectSubjunctive": {
          "eu": "decidisse",
          "tu": "decidisses",
          "você": "decidisse",
          "nós": "decidíssemos",
          "eles": "decidissem"
        },
        "futureSubjunctive": {
          "eu": "decidir",
          "tu": "decidires",
          "você": "decidir",
          "nós": "decidirmos",
          "eles": "decidirem"
        },
        "imperativeAffirmative": {
          "tu": "decide",
          "você": "decida",
          "nós": "decidamos",
          "eles": "decidam"
        },
        "imperativeNegative": {
          "tu": "não decidas",
          "você": "não decida",
          "nós": "não decidamos",
          "eles": "não decidam"
        }
      },
      "templates": [
        {
          "id": "decidir-1",
          "complementType": "fixed",
          "fixedComplement": "o caminho",
          "englishVerb": "decide",
          "englishTranslationPattern": "{pronoun} {verb} the way"
        },
        {
          "id": "decidir-2",
          "complementType": "objectSlot",
          "fixedComplement": null,
          "englishVerb": "decide",
          "englishTranslationPattern": "{pronoun} {verb} {object}"
        }
      ]
    },
    {
      "infinitive": "permitir",
      "englishMeaning": "to allow",
      "verbType": "regular-ir",
      "stemChangePattern": null,
      "conjugations": {
        "present": {
          "eu": "permito",
          "tu": "permites",
          "você": "permite",
          "nós": "permitimos",
          "eles": "permitem"
        },
        "preterite": {
          "eu": "permiti",
          "tu": "permitiste",
          "você": "permitiu",
          "nós": "permitimos",
          "eles": "permitiram"
        },
        "imperfect": {
          "eu": "permitia",
          "tu": "permitias",
          "você": "permitia",
          "nós": "permitíamos",
          "eles": "permitiam"
        },
        "future": {
          "eu": "permitirei",
          "tu": "permitirás",
          "você": "permitirá",
          "nós": "permitiremos",
          "eles": "permitirão"
        },
        "conditional": {
          "eu": "permitiria",
          "tu": "permitirias",
          "você": "permitiria",
          "nós": "permitiríamos",
          "eles": "permitiriam"
        },
        "futureProgressive": {
          "eu": "estarei permitindo",
          "tu": "estarás permitindo",
          "você": "estará permitindo",
          "nós": "estaremos permitindo",
          "eles": "estarão permitindo"
        },
        "presentSubjunctive": {
          "eu": "permita",
          "tu": "permitas",
          "você": "permita",
          "nós": "permitamos",
          "eles": "permitam"
        },
        "imperfectSubjunctive": {
          "eu": "permitisse",
          "tu": "permitisses",
          "você": "permitisse",
          "nós": "permitíssemos",
          "eles": "permitissem"
        },
        "futureSubjunctive": {
          "eu": "permitir",
          "tu": "permitires",
          "você": "permitir",
          "nós": "permitirmos",
          "eles": "permitirem"
        },
        "imperativeAffirmative": {
          "tu": "permite",
          "você": "permita",
          "nós": "permitamos",
          "eles": "permitam"
        },
        "imperativeNegative": {
          "tu": "não permitas",
          "você": "não permita",
          "nós": "não permitamos",
          "eles": "não permitam"
        }
      },
      "templates": [
        {
          "id": "permitir-1",
          "complementType": "fixed",
          "fixedComplement": "a entrada",
          "englishVerb": "allow",
          "englishTranslationPattern": "{pronoun} {verb} entry",
          "allowedPhrases": [
            "time"
          ]
        }
      ]
    },
    {
      "infinitive": "insistir",
      "englishMeaning": "to insist",
      "verbType": "regular-ir",
      "stemChangePattern": null,
      "conjugations": {
        "present": {
          "eu": "insisto",
          "tu": "insistes",
          "você": "insiste",
          "nós": "insistimos",
          "eles": "insistem"
        },
        "preterite": {
          "eu": "insisti",
          "tu": "insististe",
          "você": "insistiu",
          "nós": "insistimos",
          "eles": "insistiram"
        },
        "imperfect": {
          "eu": "insistia",
          "tu": "insistias",
          "você": "insistia",
          "nós": "insistíamos",
          "eles": "insistiam"
        },
        "future": {
          "eu": "insistirei",
          "tu": "insistirás",
          "você": "insistirá",
          "nós": "insistiremos",
          "eles": "insistirão"
        },
        "conditional": {
          "eu": "insistiria",
          "tu": "insistirias",
          "você": "insistiria",
          "nós": "insistiríamos",
          "eles": "insistiriam"
        },
        "futureProgressive": {
          "eu": "estarei insistindo",
          "tu": "estarás insistindo",
          "você": "estará insistindo",
          "nós": "estaremos insistindo",
          "eles": "estarão insistindo"
        },
        "presentSubjunctive": {
          "eu": "insista",
          "tu": "insistas",
          "você": "insista",
          "nós": "insistamos",
          "eles": "insistam"
        },
        "imperfectSubjunctive": {
          "eu": "insistisse",
          "tu": "insistisses",
          "você": "insistisse",
          "nós": "insistíssemos",
          "eles": "insistissem"
        },
        "futureSubjunctive": {
          "eu": "insistir",
          "tu": "insistires",
          "você": "insistir",
          "nós": "insistirmos",
          "eles": "insistirem"
        },
        "imperativeAffirmative": {
          "tu": "insiste",
          "você": "insista",
          "nós": "insistamos",
          "eles": "insistam"
        },
        "imperativeNegative": {
          "tu": "não insistas",
          "você": "não insista",
          "nós": "não insistamos",
          "eles": "não insistam"
        }
      },
      "templates": [
        {
          "id": "insistir-1",
          "complementType": "objectSlot",
          "fixedComplement": null,
          "englishVerb": "insist",
          "englishTranslationPattern": "{pronoun} {verb} {object}"
        }
      ]
    },
    {
      "infinitive": "assistir",
      "englishMeaning": "to watch",
      "verbType": "regular-ir",
      "stemChangePattern": null,
      "conjugations": {
        "present": {
          "eu": "assisto",
          "tu": "assistes",
          "você": "assiste",
          "nós": "assistimos",
          "eles": "assistem"
        },
        "preterite": {
          "eu": "assisti",
          "tu": "assististe",
          "você": "assistiu",
          "nós": "assistimos",
          "eles": "assistiram"
        },
        "imperfect": {
          "eu": "assistia",
          "tu": "assistias",
          "você": "assistia",
          "nós": "assistíamos",
          "eles": "assistiam"
        },
        "future": {
          "eu": "assistirei",
          "tu": "assistirás",
          "você": "assistirá",
          "nós": "assistiremos",
          "eles": "assistirão"
        },
        "conditional": {
          "eu": "assistiria",
          "tu": "assistirias",
          "você": "assistiria",
          "nós": "assistiríamos",
          "eles": "assistiriam"
        },
        "futureProgressive": {
          "eu": "estarei assistindo",
          "tu": "estarás assistindo",
          "você": "estará assistindo",
          "nós": "estaremos assistindo",
          "eles": "estarão assistindo"
        },
        "presentSubjunctive": {
          "eu": "assista",
          "tu": "assistas",
          "você": "assista",
          "nós": "assistamos",
          "eles": "assistam"
        },
        "imperfectSubjunctive": {
          "eu": "assistisse",
          "tu": "assistisses",
          "você": "assistisse",
          "nós": "assistíssemos",
          "eles": "assistissem"
        },
        "futureSubjunctive": {
          "eu": "assistir",
          "tu": "assistires",
          "você": "assistir",
          "nós": "assistirmos",
          "eles": "assistirem"
        },
        "imperativeAffirmative": {
          "tu": "assiste",
          "você": "assista",
          "nós": "assistamos",
          "eles": "assistam"
        },
        "imperativeNegative": {
          "tu": "não assistas",
          "você": "não assista",
          "nós": "não assistamos",
          "eles": "não assistam"
        }
      },
      "templates": [
        {
          "id": "assistir-1",
          "complementType": "fixed",
          "fixedComplement": "o filme",
          "englishVerb": "watch",
          "englishTranslationPattern": "{pronoun} {verb} the movie"
        },
        {
          "id": "assistir-2",
          "complementType": "objectSlot",
          "fixedComplement": null,
          "englishVerb": "watch",
          "englishTranslationPattern": "{pronoun} {verb} {object}"
        }
      ]
    },
    {
      "infinitive": "discutir",
      "englishMeaning": "to discuss",
      "verbType": "regular-ir",
      "stemChangePattern": null,
      "conjugations": {
        "present": {
          "eu": "discuto",
          "tu": "discutes",
          "você": "discute",
          "nós": "discutimos",
          "eles": "discutem"
        },
        "preterite": {
          "eu": "discuti",
          "tu": "discutiste",
          "você": "discutiu",
          "nós": "discutimos",
          "eles": "discutiram"
        },
        "imperfect": {
          "eu": "discutia",
          "tu": "discutias",
          "você": "discutia",
          "nós": "discutíamos",
          "eles": "discutiam"
        },
        "future": {
          "eu": "discutirei",
          "tu": "discutirás",
          "você": "discutirá",
          "nós": "discutiremos",
          "eles": "discutirão"
        },
        "conditional": {
          "eu": "discutiria",
          "tu": "discutirias",
          "você": "discutiria",
          "nós": "discutiríamos",
          "eles": "discutiriam"
        },
        "futureProgressive": {
          "eu": "estarei discutindo",
          "tu": "estarás discutindo",
          "você": "estará discutindo",
          "nós": "estaremos discutindo",
          "eles": "estarão discutindo"
        },
        "presentSubjunctive": {
          "eu": "discuta",
          "tu": "discutas",
          "você": "discuta",
          "nós": "discutamos",
          "eles": "discutam"
        },
        "imperfectSubjunctive": {
          "eu": "discutisse",
          "tu": "discutisses",
          "você": "discutisse",
          "nós": "discutíssemos",
          "eles": "discutissem"
        },
        "futureSubjunctive": {
          "eu": "discutir",
          "tu": "discutires",
          "você": "discutir",
          "nós": "discutirmos",
          "eles": "discutirem"
        },
        "imperativeAffirmative": {
          "tu": "discute",
          "você": "discuta",
          "nós": "discutamos",
          "eles": "discutam"
        },
        "imperativeNegative": {
          "tu": "não discutas",
          "você": "não discuta",
          "nós": "não discutamos",
          "eles": "não discutam"
        }
      },
      "templates": [
        {
          "id": "discutir-1",
          "complementType": "fixed",
          "fixedComplement": "o assunto",
          "englishVerb": "discuss",
          "englishTranslationPattern": "{pronoun} {verb} the subject"
        },
        {
          "id": "discutir-2",
          "complementType": "none",
          "fixedComplement": null,
          "englishVerb": "argue",
          "englishTranslationPattern": "{pronoun} {verb}"
        }
      ]
    },
    {
      "infinitive": "partir",
      "englishMeaning": "to leave",
      "verbType": "regular-ir",
      "stemChangePattern": null,
      "conjugations": {
        "present": {
          "eu": "parto",
          "tu": "partes",
          "você": "parte",
          "nós": "partimos",
          "eles": "partem"
        },
        "preterite": {
          "eu": "parti",
          "tu": "partiste",
          "você": "partiu",
          "nós": "partimos",
          "eles": "partiram"
        },
        "imperfect": {
          "eu": "partia",
          "tu": "partias",
          "você": "partia",
          "nós": "partíamos",
          "eles": "partiam"
        },
        "future": {
          "eu": "partirei",
          "tu": "partirás",
          "você": "partirá",
          "nós": "partiremos",
          "eles": "partirão"
        },
        "conditional": {
          "eu": "partiria",
          "tu": "partirias",
          "você": "partiria",
          "nós": "partiríamos",
          "eles": "partiriam"
        },
        "futureProgressive": {
          "eu": "estarei partindo",
          "tu": "estarás partindo",
          "você": "estará partindo",
          "nós": "estaremos partindo",
          "eles": "estarão partindo"
        },
        "presentSubjunctive": {
          "eu": "parta",
          "tu": "partas",
          "você": "parta",
          "nós": "partamos",
          "eles": "partam"
        },
        "imperfectSubjunctive": {
          "eu": "partisse",
          "tu": "partisses",
          "você": "partisse",
          "nós": "partíssemos",
          "eles": "partissem"
        },
        "futureSubjunctive": {
          "eu": "partir",
          "tu": "partires",
          "você": "partir",
          "nós": "partirmos",
          "eles": "partirem"
        },
        "imperativeAffirmative": {
          "tu": "parte",
          "você": "parta",
          "nós": "partamos",
          "eles": "partam"
        },
        "imperativeNegative": {
          "tu": "não partas",
          "você": "não parta",
          "nós": "não partamos",
          "eles": "não partam"
        }
      },
      "templates": [
        {
          "id": "partir-1",
          "complementType": "none",
          "fixedComplement": null,
          "englishVerb": "leave",
          "englishTranslationPattern": "{pronoun} {verb}",
          "allowedPhrases": [
            "time",
            "manner"
          ]
        }
      ]
    },
    {
      "infinitive": "dormir",
      "englishMeaning": "to sleep",
      "verbType": "stem-changing",
      "stemChangePattern": "o→u",
      "conjugations": {
        "present": {
          "eu": "durmo",
          "tu": "dormes",
          "você": "dorme",
          "nós": "dormimos",
          "eles": "dormem"
        },
        "preterite": {
          "eu": "dormi",
          "tu": "dormiste",
          "você": "dormiu",
          "nós": "dormimos",
          "eles": "dormiram"
        },
        "imperfect": {
          "eu": "dormia",
          "tu": "dormias",
          "você": "dormia",
          "nós": "dormíamos",
          "eles": "dormiam"
        },
        "future": {
          "eu": "dormirei",
          "tu": "dormirás",
          "você": "dormirá",
          "nós": "dormiremos",
          "eles": "dormirão"
        },
        "conditional": {
          "eu": "dormiria",
          "tu": "dormirias",
          "você": "dormiria",
          "nós": "dormiríamos",
          "eles": "dormiriam"
        },
        "futureProgressive": {
          "eu": "estarei dormindo",
          "tu": "estarás dormindo",
          "você": "estará dormindo",
          "nós": "estaremos dormindo",
          "eles": "estarão dormindo"
        },
        "presentSubjunctive": {
          "eu": "durma",
          "tu": "durmas",
          "você": "durma",
          "nós": "durmamos",
          "eles": "durmam"
        },
        "imperfectSubjunctive": {
          "eu": "dormisse",
          "tu": "dormisses",
          "você": "dormisse",
          "nós": "dormíssemos",
          "eles": "dormissem"
        },
        "futureSubjunctive": {
          "eu": "dormir",
          "tu": "dormires",
          "você": "dormir",
          "nós": "dormirmos",
          "eles": "dormirem"
        },
        "imperativeAffirmative": {
          "tu": "dorme",
          "você": "durma",
          "nós": "durmamos",
          "eles": "durmam"
        },
        "imperativeNegative": {
          "tu": "não durmas",
          "você": "não durma",
          "nós": "não durmamos",
          "eles": "não durmam"
        }
      },
      "templates": [
        {
          "id": "dormir-1",
          "complementType": "none",
          "fixedComplement": null,
          "englishVerb": "sleep",
          "englishTranslationPattern": "{pronoun} {verb}"
        }
      ],
      "stemChange": {
        "from": "o",
        "to": "u",
        "tenses": {
          "present": [
            "eu"
          ],
          "presentSubjunctive": [
            "eu",
            "tu",
            "você",
            "nós",
            "vós",
            "eles"
          ]
        }
      }
    },
    {
      "infinitive": "sentir",
      "englishMeaning": "to feel",
      "verbType": "stem-changing",
      "stemChangePattern": "e→i",
      "conjugations": {
        "present": {
          "eu": "sinto",
          "tu": "sentes",
          "você": "sente",
          "nós": "sentimos",
          "eles": "sentem"
        },
        "preterite": {
          "eu": "senti",
          "tu": "sentiste",
          "você": "sentiu",
          "nós": "sentimos",
          "eles": "sentiram"
        },
        "imperfect": {
          "eu": "sentia",
          "tu": "sentias",
          "você": "sentia",
          "nós": "sentíamos",
          "eles": "sentiam"
        },
        "future": {
          "eu": "sentirei",
          "tu": "sentirás",
          "você": "sentirá",
          "nós": "sentiremos",
          "eles": "sentirão"
        },
        "conditional": {
          "eu": "sentiria",
          "tu": "sentirias",
          "você": "sentiria",
          "nós": "sentiríamos",
          "eles": "sentiriam"
        },
        "futureProgressive": {
          "eu": "estarei sentindo",
          "tu": "estarás sentindo",
          "você": "estará sentindo",
          "nós": "estaremos sentindo",
          "eles": "estarão sentindo"
        },
        "presentSubjunctive": {
          "eu": "sinta",
          "tu": "sintas",
          "você": "sinta",
          "nós": "sintamos",
          "eles": "sintam"
        },
        "imperfectSubjunctive": {
          "eu": "sentisse",
          "tu": "sentisses",
          "você": "sentisse",
          "nós": "sentíssemos",
          "eles": "sentissem"
        },
        "futureSubjunctive": {
          "eu": "sentir",
          "tu": "sentires",
          "você": "sentir",
          "nós": "sentirmos",
          "eles": "sentirem"
        },
        "imperativeAffirmative": {
          "tu": "sente",
          "você": "sinta",
          "nós": "sintamos",
          "eles": "sintam"
        },
        "imperativeNegative": {
          "tu": "não sintas",
          "você": "não sinta",
          "nós": "não sintamos",
          "eles": "não sintam"
        }
      },
      "templates": [
        {
          "id": "sentir-1",
          "complementType": "fixed",
          "fixedComplement": "frio",
          "englishVerb": "feel",
          "englishTranslationPattern": "{pronoun} {verb} cold",
          "allowedPhrases": [
            "time",
            "location"
          ]
        },
        {
          "id": "sentir-2",
          "complementType": "objectSlot",
          "fixedComplement": null,
          "englishVerb": "feel",
          "englishTranslationPattern": "{pronoun} {verb} {object}"
        }
      ],
      "stemChange": {
        "from": "e",
        "to": "i",
        "tenses": {
          "present": [
            "eu"
          ],
          "presentSubjunctive": [
            "eu",
            "tu",
            "você",
            "nós",
            "vós",
            "eles"
          ]
        }
      }
    },
    {
      "infinitive": "preferir",
      "englishMeaning": "to prefer",
      "verbType": "stem-changing",
      "stemChangePattern": "e→i",
      "conjugations": {
        "present": {
          "eu": "prefiro",
          "tu": "preferes",
          "você": "prefere",
          "nós": "preferimos",
          "eles": "preferem"
        },
        "preterite": {
          "eu": "preferi",
          "tu": "preferiste",
          "você": "preferiu",
          "nós": "preferimos",
          "eles": "preferiram"
        },
        "imperfect": {
          "eu": "preferia",
          "tu": "preferias",
          "você": "preferia",
          "nós": "preferíamos",
          "eles": "preferiam"
        },
        "future": {
          "eu": "preferirei",
          "tu": "preferirás",
          "você": "preferirá",
          "nós": "preferiremos",
          "eles": "preferirão"
        },
        "conditional": {
          "eu": "preferiria",
          "tu": "preferirias",
          "você": "preferiria",
          "nós": "preferiríamos",
          "eles": "prefeririam"
        },
        "futureProgressive": {
          "eu": "estarei preferindo",
          "tu": "estarás preferindo",
          "você": "estará preferindo",
          "nós": "estaremos preferindo",
          "eles": "estarão preferindo"
        },
        "presentSubjunctive": {
          "eu": "prefira",
          "tu": "prefiras",
          "você": "prefira",
          "nós": "prefiramos",
          "eles": "prefiram"
        },
        "imperfectSubjunctive": {
          "eu": "preferisse",
          "tu": "preferisses",
          "você": "preferisse",
          "nós": "preferíssemos",
          "eles": "preferissem"
        },
        "futureSubjunctive": {
          "eu": "preferir",
          "tu": "preferires",
          "você": "preferir",
          "nós": "preferirmos",
          "eles": "preferirem"
        },
        "imperativeAffirmative": {
          "tu": "prefere",
          "você": "prefira",
          "nós": "prefiramos",
          "eles": "prefiram"
        },
        "imperativeNegative": {
          "tu": "não prefiras",
          "você": "não prefira",
          "nós": "não prefiramos",
          "eles": "não prefiram"
        }
      },
      "templates": [
        {
          "id": "preferir-1",
          "complementType": "fixed",
          "fixedComplement": "café",
          "englishVerb": "prefer",
          "englishTranslationPattern": "{pronoun} {verb} coffee",
          "allowedPhrases": [
            "time",
            "location"
          ]
        },
        {
          "id": "preferir-2",
          "complementType": "objectSlot",
          "fixedComplement": null,
          "englishVerb": "prefer",
          "englishTranslationPattern": "{pronoun} {verb} {object}"
        }
      ],
      "stemChange": {
        "from": "e",
        "to": "i",
        "tenses": {
          "present": [
            "eu"
          ],
          "presentSubjunctive": [
            "eu",
            "tu",
            "você",
            "nós",
            "vós",
            "eles"
          ]
        }
      }
    },
    {
      "infinitive": "repetir",
      "englishMeaning": "to repeat",
      "verbType": "stem-changing",
      "stemChangePattern": "e→i",
      "conjugations": {
        "present": {
          "eu": "repito",
          "tu": "repetes",
          "você": "repete",
          "nós": "repetimos",
          "eles": "repetem"
        },
        "preterite": {
          "eu": "repeti",
          "tu": "repetiste",
          "você": "repetiu",
          "nós": "repetimos",
          "eles": "repetiram"
        },
        "imperfect": {
          "eu": "repetia",
          "tu": "repetias",
          "você": "repetia",
          "nós": "repetíamos",
          "eles": "repetiam"
        },
        "future": {
          "eu": "repetirei",
          "tu": "repetirás",
          "você": "repetirá",
          "nós": "repetiremos",
          "eles": "repetirão"
        },
        "conditional": {
          "eu": "repetiria",
          "tu": "repetirias",
          "você": "repetiria",
          "nós": "repetiríamos",
          "eles": "repetiriam"
        },
        "futureProgressive": {
          "eu": "estarei repetindo",
          "tu": "estarás repetindo",
          "você": "estará repetindo",
          "nós": "estaremos repetindo",
          "eles": "estarão repetindo"
        },
        "presentSubjunctive": {
          "eu": "repita",
          "tu": "repitas",
          "você": "repita",
          "nós": "repitamos",
          "eles": "repitam"
        },
        "imperfectSubjunctive": {
          "eu": "repetisse",
          "tu": "repetisses",
          "você": "repetisse",
          "nós": "repetíssemos",
          "eles": "repetissem"
        },
        "futureSubjunctive": {
          "eu": "repetir",
          "tu": "repetires",
          "você": "repetir",
          "nós": "repetirmos",
          "eles": "repetirem"
        },
        "imperativeAffirmative": {
          "tu": "repete",
          "você": "repita",
          "nós": "repitamos",
          "eles": "repitam"
        },
        "imperativeNegative": {
          "tu": "não repitas",
          "você": "não repita",
          "nós": "não repitamos",
          "eles": "não repitam"
        }
      },
      "templates": [
        {
          "id": "repetir-1",
          "complementType": "fixed",
          "fixedComplement": "a frase",
          "englishVerb": "repeat",
          "englishTranslationPattern": "{pronoun} {verb} the sentence"
        },
        {
          "id": "repetir-2",
          "complementType": "objectSlot",
          "fixedComplement": null,
          "englishVerb": "repeat",
          "englishTranslationPattern": "{pronoun} {verb} {object}"
        }
      ],
      "stemChange": {
        "from": "e",
        "to": "i",
        "tenses": {
          "present": [
            "eu"
          ],
          "presentSubjunctive": [
            "eu",
            "tu",
            "você",
            "nós",
            "vós",
            "eles"
          ]
        }
      }
    },
    {
      "infinitive": "servir",
      "englishMeaning": "to serve",
      "verbType": "stem-changing",
      "stemChangePattern": "e→i",
      "conjugations": {
        "present": {
          "eu": "sirvo",
          "tu": "serves",
          "você": "serve",
          "nós": "servimos",
          "eles": "servem"
        },
        "preterite": {
          "eu": "servi",
          "tu": "serviste",
          "você": "serviu",
          "nós": "servimos",
          "eles": "serviram"
        },
        "imperfect": {
          "eu": "servia",
          "tu": "servias",
          "você": "servia",
          "nós": "servíamos",
          "eles": "serviam"
        },
        "future": {
          "eu": "servirei",
          "tu": "servirás",
          "você": "servirá",
          "nós": "serviremos",
          "eles": "servirão"
        },
        "conditional": {
          "eu": "serviria",
          "tu": "servirias",
          "você": "serviria",
          "nós": "serviríamos",
          "eles": "serviriam"
        },
        "futureProgressive": {
          "eu": "estarei servindo",
          "tu": "estarás servindo",
          "você": "estará servindo",
          "nós": "estaremos servindo",
          "eles": "estarão servindo"
        },
        "presentSubjunctive": {
          "eu": "sirva",
          "tu": "sirvas",
          "você": "sirva",
          "nós": "sirvamos",
          "eles": "sirvam"
        },
        "imperfectSubjunctive": {
          "eu": "servisse",
          "tu": "servisses",
          "você": "servisse",
          "nós": "servíssemos",
          "eles": "servissem"
        },
        "futureSubjunctive": {
          "eu": "servir",
          "tu": "servires",
          "você": "servir",
          "nós": "servirmos",
          "eles": "servirem"
        },
        "imperativeAffirmative": {
          "tu": "serve",
          "você": "sirva",
          "nós": "sirvamos",
          "eles": "sirvam"
        },
        "imperativeNegative": {
          "tu": "não sirvas",
          "você": "não sirva",
          "nós": "não sirvamos",
          "eles": "não sirvam"
        }
      },
      "templates": [
        {
          "id": "servir-1",
          "complementType": "fixed",
          "fixedComplement": "o almoço",
          "englishVerb": "serve",
          "englishTranslationPattern": "{pronoun} {verb} lunch"
        },
        {
          "id": "servir-2",
          "complementType": "objectSlot",
          "fixedComplement": null,
          "englishVerb": "serve",
          "englishTranslationPattern": "{pronoun} {verb} {object}"
        }
      ],
      "stemChange": {
        "from": "e",
        "to": "i",
        "tenses": {
          "present": [
            "eu"
          ],
          "presentSubjunctive": [
            "eu",
            "tu",
            "você",
            "nós",
            "vós",
            "eles"
          ]
        }
      }
    },
    {
      "infinitive": "seguir",
      "englishMeaning": "to follow",
      "verbType": "stem-changing",
      "stemChangePattern": "e→i",
      "conjugations": {
        "present": {
          "eu": "sigo",
          "tu": "segues",
          "você": "segue",
          "nós": "seguimos",
          "eles": "seguem"
        },
        "preterite": {
          "eu": "segui",
          "tu": "seguiste",
          "você": "seguiu",
          "nós": "seguimos",
          "eles": "seguiram"
        },
        "imperfect": {
          "eu": "seguia",
          "tu": "seguias",
          "você": "seguia",
          "nós": "seguíamos",
          "eles": "seguiam"
        },
        "future": {
          "eu": "seguirei",
          "tu": "seguirás",
          "você": "seguirá",
          "nós": "seguiremos",
          "eles": "seguirão"
        },
        "conditional": {
          "eu": "seguiria",
          "tu": "seguirias",
          "você": "seguiria",
          "nós": "seguiríamos",
          "eles": "seguiriam"
        },
        "futureProgressive": {
          "eu": "estarei seguindo",
          "tu": "estarás seguindo",
          "você": "estará seguindo",
          "nós": "estaremos seguindo",
          "eles": "estarão seguindo"
        },
        "presentSubjunctive": {
          "eu": "siga",
          "tu": "sigas",
          "você": "siga",
          "nós": "sigamos",
          "eles": "sigam"
        },
        "imperfectSubjunctive": {
          "eu": "seguisse",
          "tu": "seguisses",
          "você": "seguisse",
          "nós": "seguíssemos",
          "eles": "seguissem"
        },
        "futureSubjunctive": {
          "eu": "seguir",
          "tu": "seguires",
          "você": "seguir",
          "nós": "seguirmos",
          "eles": "seguirem"
        },
        "imperativeAffirmative": {
          "tu": "segue",
          "você": "siga",
          "nós": "sigamos",
          "eles": "sigam"
        },
        "imperativeNegative": {
          "tu": "não sigas",
          "você": "não siga",
          "nós": "não sigamos",
          "eles": "não sigam"
        }
      },
      "templates": [
        {
          "id": "seguir-1",
          "complementType": "fixed",
          "fixedComplement": "as regras",
          "englishVerb": "follow",
          "englishTranslationPattern": "{pronoun} {verb} the rules"
        },
        {
          "id": "seguir-2",
          "complementType": "objectSlot",
          "fixedComplement": null,
          "englishVerb": "follow",
          "englishTranslationPattern": "{pronoun} {verb} {object}"
        }
      ],
      "stemChange": {
        "from": "e",
        "to": "i",
        "tenses": {
          "present": [
            "eu"
          ],
          "presentSubjunctive": [
            "eu",
            "tu",
            "você",
            "nós",
            "vós",
            "eles"
          ]
        }
      }
    },
    {
      "infinitive": "pedir",
      "englishMeaning": "to ask for",
      "verbType": "stem-changing",
      "stemChangePattern": "d→ç",
      "conjugations": {
        "present": {
          "eu": "peço",
          "tu": "pedes",
          "você": "pede",
          "nós": "pedimos",
          "eles": "pedem"
        },
        "preterite": {
          "eu": "pedi",
          "tu": "pediste",
          "você": "pediu",
          "nós": "pedimos",
          "eles": "pediram"
        },
        "imperfect": {
          "eu": "pedia",
          "tu": "pedias",
          "você": "pedia",
          "nós": "pedíamos",
          "eles": "pediam"
        },
        "future": {
          "eu": "pedirei",
          "tu": "pedirás",
          "você": "pedirá",
          "nós": "pediremos",
          "eles": "pedirão"
        },
        "conditional": {
          "eu": "pediria",
          "tu": "pedirias",
          "você": "pediria",
          "nós": "pediríamos",
          "eles": "pediriam"
        },
        "futureProgressive": {
          "eu": "estarei pedindo",
          "tu": "estarás pedindo",
          "você": "estará pedindo",
          "nós": "estaremos pedindo",
          "eles": "estarão pedindo"
        },
        "presentSubjunctive": {
          "eu": "peça",
          "tu": "peças",
          "você": "peça",
          "nós": "peçamos",
          "eles": "peçam"
        },
        "imperfectSubjunctive": {
          "eu": "pedisse",
          "tu": "pedisses",
          "você": "pedisse",
          "nós": "pedíssemos",
          "eles": "pedissem"
        },
        "futureSubjunctive": {
          "eu": "pedir",
          "tu": "pedires",
          "você": "pedir",
          "nós": "pedirmos",
          "eles": "pedirem"
        },
        "imperativeAffirmative": {
          "tu": "pede",
          "você": "peça",
          "nós": "peçamos",
          "eles": "peçam"
        },
        "imperativeNegative": {
          "tu": "não peças",
          "você": "não peça",
          "nós": "não peçamos",
          "eles": "não peçam"
        }
      },
      "templates": [
        {
          "id": "pedir-1",
          "complementType": "fixed",
          "fixedComplement": "ajuda",
          "englishVerb": "ask for",
          "englishTranslationPattern": "{pronoun} {verb} help"
        },
        {
          "id": "pedir-2",
          "complementType": "objectSlot",
          "fixedComplement": null,
          "englishVerb": "ask for",
          "englishTranslationPattern": "{pronoun} {verb} {object}"
        }
      ],
      "stemChange": {
        "from": "d",
        "to": "ç",
        "tenses": {
          "present": [
            "eu"
          ],
          "presentSubjunctive": [
            "eu",
            "tu",
            "você",
            "nós",
            "vós",
            "eles"
          ]
        }
      }
    },
    {
      "infinitive": "medir",
      "englishMeaning": "to measure",
      "verbType": "stem-changing",
      "stemChangePattern": "d→ç",
      "conjugations": {
        "present": {
          "eu": "meço",
          "tu": "medes",
          "você": "mede",
          "nós": "medimos",
          "eles": "medem"
        },
        "preterite": {
          "eu": "medi",
          "tu": "mediste",
          "você": "mediu",
          "nós": "medimos",
          "eles": "mediram"
        },
        "imperfect": {
          "eu": "media",
          "tu": "medias",
          "você": "media",
          "nós": "medíamos",
          "eles": "mediam"
        },
        "future": {
          "eu": "medirei",
          "tu": "medirás",
          "você": "medirá",
          "nós": "mediremos",
          "eles": "medirão"
        },
        "conditional": {
          "eu": "mediria",
          "tu": "medirias",
          "você": "mediria",
          "nós": "mediríamos",
          "eles": "mediriam"
        },
        "futureProgressive": {
          "eu": "estarei medindo",
          "tu": "estarás medindo",
          "você": "estará medindo",
          "nós": "estaremos medindo",
          "eles": "estarão medindo"
        },
        "presentSubjunctive": {
          "eu": "meça",
          "tu": "meças",
          "você": "meça",
          "nós": "meçamos",
          "eles": "meçam"
        },
        "imperfectSubjunctive": {
          "eu": "medisse",
          "tu": "medisses",
          "você": "medisse",
          "nós": "medíssemos",
          "eles": "medissem"
        },
        "futureSubjunctive": {
          "eu": "medir",
          "tu": "medires",
          "você": "medir",
          "nós": "medirmos",
          "eles": "medirem"
        },
        "imperativeAffirmative": {
          "tu": "mede",
          "você": "meça",
          "nós": "meçamos",
          "eles": "meçam"
        },
        "imperativeNegative": {
          "tu": "não meças",
          "você": "não meça",
          "nós": "não meçamos",
          "eles": "não meçam"
        }
      },
      "templates": [
        {
          "id": "medir-1",
          "complementType": "fixed",
          "fixedComplement": "a mesa",
          "englishVerb": "measure",
          "englishTranslationPattern": "{pronoun} {verb} the table"
        },
        {
          "id": "medir-2",
          "complementType": "objectSlot",
          "fixedComplement": null,
          "englishVerb": "measure",
          "englishTranslationPattern": "{pronoun} {verb} {object}"
        }
      ],
      "stemChange": {
        "from": "d",
        "to": "ç",
        "tenses": {
          "present": [
            "eu"
          ],
          "presentSubjunctive": [
            "eu",
            "tu",
            "você",
            "nós",
            "vós",
            "eles"
          ]
        }
      }
    },
    {
      "infinitive": "vestir",
      "englishMeaning": "to wear",
      "verbType": "stem-changing",
      "stemChangePattern": "e→i",
      "conjugations": {
        "present": {
          "eu": "visto",
          "tu": "vestes",
          "você": "veste",
          "nós": "vestimos",
          "eles": "vestem"
        },
        "preterite": {
          "eu": "vesti",
          "tu": "vestiste",
          "você": "vestiu",
          "nós": "vestimos",
          "eles": "vestiram"
        },
        "imperfect": {
          "eu": "vestia",
          "tu": "vestias",
          "você": "vestia",
          "nós": "vestíamos",
          "eles": "vestiam"
        },
        "future": {
          "eu": "vestirei",
          "tu": "vestirás",
          "você": "vestirá",
          "nós": "vestiremos",
          "eles": "vestirão"
        },
        "conditional": {
          "eu": "vestiria",
          "tu": "vestirias",
          "você": "vestiria",
          "nós": "vestiríamos",
          "eles": "vestiriam"
        },
        "futureProgressive": {
          "eu": "estarei vestindo",
          "tu": "estarás vestindo",
          "você": "estará vestindo",
          "nós": "estaremos vestindo",
          "eles": "estarão vestindo"
        },
        "presentSubjunctive": {
          "eu": "vista",
          "tu": "vistas",
          "você": "vista",
          "nós": "vistamos",
          "eles": "vistam"
        },
        "imperfectSubjunctive": {
          "eu": "vestisse",
          "tu": "vestisses",
          "você": "vestisse",
          "nós": "vestíssemos",
          "eles": "vestissem"
        },
        "futureSubjunctive": {
          "eu": "vestir",
          "tu": "vestires",
          "você": "vestir",
          "nós": "vestirmos",
          "eles": "vestirem"
        },
        "imperativeAffirmative": {
          "tu": "veste",
          "você": "vista",
          "nós": "vistamos",
          "eles": "vistam"
        },
        "imperativeNegative": {
          "tu": "não vistas",
          "você": "não vista",
          "nós": "não vistamos",
          "eles": "não vistam"
        }
      },
      "templates": [
        {
          "id": "vestir-1",
          "complementType": "fixed",
          "fixedComplement": "o casaco",
          "englishVerb": "wear",
          "englishTranslationPattern": "{pronoun} {verb} the coat"
        },
        {
          "id": "vestir-2",
          "complementType": "objectSlot",
          "fixedComplement": null,
          "englishVerb": "wear",
          "englishTranslationPattern": "{pronoun} {verb} {object}"
        }
      ],
      "stemChange": {
        "from": "e",
        "to": "i",
        "tenses": {
          "present": [
            "eu"
          ],
          "presentSubjunctive": [
            "eu",
            "tu",
            "você",
            "nós",
            "vós",
            "eles"
          ]
        }
      }
    },
    {
      "infinitive": "conseguir",
      "englishMeaning": "to manage to",
      "verbType": "stem-changing",
      "stemChangePattern": "e→i",
      "conjugations": {
        "present": {
          "eu": "consigo",
          "tu": "consegues",
          "você": "consegue",
          "nós": "conseguimos",
          "eles": "conseguem"
        },
        "preterite": {
          "eu": "consegui",
          "tu": "conseguiste",
          "você": "conseguiu",
          "nós": "conseguimos",
          "eles": "conseguiram"
        },
        "imperfect": {
          "eu": "conseguia",
          "tu": "conseguias",
          "você": "conseguia",
          "nós": "conseguíamos",
          "eles": "conseguiam"
        },
        "future": {
          "eu": "conseguirei",
          "tu": "conseguirás",
          "você": "conseguirá",
          "nós": "conseguiremos",
          "eles": "conseguirão"
        },
        "conditional": {
          "eu": "conseguiria",
          "tu": "conseguirias",
          "você": "conseguiria",
          "nós": "conseguiríamos",
          "eles": "conseguiriam"
        },
        "futureProgressive": {
          "eu": "estarei conseguindo",
          "tu": "estarás conseguindo",
          "você": "estará conseguindo",
          "nós": "estaremos conseguindo",
          "eles": "estarão conseguindo"
        },
        "presentSubjunctive": {
          "eu": "consiga",
          "tu": "consigas",
          "você": "consiga",
          "nós": "consigamos",
          "eles": "consigam"
        },
        "imperfectSubjunctive": {
          "eu": "conseguisse",
          "tu": "conseguisses",
          "você": "conseguisse",
          "nós": "conseguíssemos",
          "eles": "conseguissem"
        },
        "futureSubjunctive": {
          "eu": "conseguir",
          "tu": "conseguires",
          "você": "conseguir",
          "nós": "conseguirmos",
          "eles": "conseguirem"
        },
        "imperativeAffirmative": {
          "tu": "consegue",
          "você": "consiga",
          "nós": "consigamos",
          "eles": "consigam"
        },
        "imperativeNegative": {
          "tu": "não consigas",
          "você": "não consiga",
          "nós": "não consigamos",
          "eles": "não consigam"
        }
      },
      "templates": [
        {
          "id": "conseguir-1",
          "complementType": "fixed",
          "fixedComplement": "um emprego",
          "englishVerb": "get",
          "englishTranslationPattern": "{pronoun} {verb} a job",
          "allowedPhrases": [
            "time",
            "manner"
          ]
        },
        {
          "id": "conseguir-2",
          "complementType": "objectSlot",
          "fixedComplement": null,
          "englishVerb": "manage",
          "englishTranslationPattern": "{pronoun} {verb} {object}"
        }
      ],
      "stemChange": {
        "from": "e",
        "to": "i",
        "tenses": {
          "present": [
            "eu"
          ],
          "presentSubjunctive": [
            "eu",
            "tu",
            "você",
            "nós",
            "vós",
            "eles"
          ]
        }
      }
    },
    {
      "infinitive": "conhecer",
      "englishMeaning": "to know",
      "verbType": "stem-changing",
      "stemChangePattern": "c→ç",
      "conjugations": {
        "present": {
          "eu": "conheço",
          "tu": "conheces",
          "você": "conhece",
          "nós": "conhecemos",
          "eles": "conhecem"
        },
        "preterite": {
          "eu": "conheci",
          "tu": "conheceste",
          "você": "conheceu",
          "nós": "conhecemos",
          "eles": "conheceram"
        },
        "imperfect": {
          "eu": "conhecia",
          "tu": "conhecias",
          "você": "conhecia",
          "nós": "conhecíamos",
          "eles": "conheciam"
        },
        "future": {
          "eu": "conhecerei",
          "tu": "conhecerás",
          "você": "conhecerá",
          "nós": "conheceremos",
          "eles": "conhecerão"
        },
        "conditional": {
          "eu": "conheceria",
          "tu": "conhecerias",
          "você": "conheceria",
          "nós": "conheceríamos",
          "eles": "conheceriam"
        },
        "futureProgressive": {
          "eu": "estarei conhecendo",
          "tu": "estarás conhecendo",
          "você": "estará conhecendo",
          "nós": "estaremos conhecendo",
          "eles": "estarão conhecendo"
        },
        "presentSubjunctive": {
          "eu": "conheça",
          "tu": "conheças",
          "você": "conheça",
          "nós": "conheçamos",
          "eles": "conheçam"
        },
        "imperfectSubjunctive": {
          "eu": "conhecesse",
          "tu": "conhecesses",
          "você": "conhecesse",
          "nós": "conhecêssemos",
          "eles": "conhecessem"
        },
        "futureSubjunctive": {
          "eu": "conhecer",
          "tu": "conheceres",
          "você": "conhecer",
          "nós": "conhecermos",
          "eles": "conhecerem"
        },
        "imperativeAffirmative": {
          "tu": "conhece",
          "você": "conheça",
          "nós": "conheçamos",
          "eles": "conheçam"
        },
        "imperativeNegative": {
          "tu": "não conheças",
          "você": "não conheça",
          "nós": "não conheçamos",
          "eles": "não conheçam"
        }
      },
      "templates": [
        {
          "id": "conhecer-1",
          "complementType": "objectSlot",
          "fixedComplement": null,
          "englishVerb": "know",
          "englishTranslationPattern": "{pronoun} {verb} {object}"
        }
      ],
      "stemChange": {
        "from": "c",
        "to": "ç",
        "tenses": {
          "present": [
            "eu"
          ],
          "presentSubjunctive": [
            "eu",
            "tu",
            "você",
            "nós",
            "vós",
            "eles"
          ]
        }
      }
    },
    {
      "infinitive": "dirigir",
      "englishMeaning": "to drive",
      "verbType": "stem-changing",
      "stemChangePattern": "g→j",
      "conjugations": {
        "present": {
          "eu": "dirijo",
          "tu": "diriges",
          "você": "dirige",
          "nós": "dirigimos",
          "eles": "dirigem"
        },
        "preterite": {
          "eu": "dirigi",
          "tu": "dirigiste",
          "você": "dirigiu",
          "nós": "dirigimos",
          "eles": "dirigiram"
        },
        "imperfect": {
          "eu": "dirigia",
          "tu": "dirigias",
          "você": "dirigia",
          "nós": "dirigíamos",
          "eles": "dirigiam"
        },
        "future": {
          "eu": "dirigirei",
          "tu": "dirigirás",
          "você": "dirigirá",
          "nós": "dirigiremos",
          "eles": "dirigirão"
        },
        "conditional": {
          "eu": "dirigiria",
          "tu": "dirigirias",
          "você": "dirigiria",
          "nós": "dirigiríamos",
          "eles": "dirigiriam"
        },
        "futureProgressive": {
          "eu": "estarei dirigindo",
          "tu": "estarás dirigindo",
          "você": "estará dirigindo",
          "nós": "estaremos dirigindo",
          "eles": "estarão dirigindo"
        },
        "presentSubjunctive": {
          "eu": "dirija",
          "tu": "dirijas",
          "você": "dirija",
          "nós": "dirijamos",
          "eles": "dirijam"
        },
        "imperfectSubjunctive": {
          "eu": "dirigisse",
          "tu": "dirigisses",
          "você": "dirigisse",
          "nós": "dirigíssemos",
          "eles": "dirigissem"
        },
        "futureSubjunctive": {
          "eu": "dirigir",
          "tu": "dirigires",
          "você": "dirigir",
          "nós": "dirigirmos",
          "eles": "dirigirem"
        },
        "imperativeAffirmative": {
          "tu": "dirige",
          "você": "dirija",
          "nós": "dirijamos",
          "eles": "dirijam"
        },
        "imperativeNegative": {
          "tu": "não dirijas",
          "você": "não dirija",
          "nós": "não dirijamos",
          "eles": "não dirijam"
        }
      },
      "templates": [
        {
          "id": "dirigir-1",
          "complementType": "objectSlot",
          "fixedComplement": null,
          "englishVerb": "drive",
          "englishTranslationPattern": "{pronoun} {verb} {object}"
        }
      ],
      "stemChange": {
        "from": "g",
        "to": "j",
        "tenses": {
          "present": [
            "eu"
          ],
          "presentSubjunctive": [
            "eu",
            "tu",
            "você",
            "nós",
            "vós",
            "eles"
          ]
        }
      }
    },
    {
      "infinitive": "ser",
      "englishMeaning": "to be",
      "verbType": "irregular",
      "stemChangePattern": null,
      "conjugations": {
        "present": {
          "eu": "sou",
          "tu": "és",
          "você": "é",
          "nós": "somos",
          "eles": "são"
        },
        "preterite": {
          "eu": "fui",
          "tu": "foste",
          "você": "foi",
          "nós": "fomos",
          "eles": "foram"
        },
        "imperfect": {
          "eu": "era",
          "tu": "eras",
          "você": "era",
          "nós": "éramos",
          "eles": "eram"
        },
        "future": {
          "eu": "serei",
          "tu": "serás",
          "você": "será",
          "nós": "seremos",
          "eles": "serão"
        },
        "conditional": {
          "eu": "seria",
          "tu": "serias",
          "você": "seria",
          "nós": "seríamos",
          "eles": "seriam"
        },
        "futureProgressive": {
          "eu": "estarei sendo",
          "tu": "estarás sendo",
          "você": "estará sendo",
          "nós": "estaremos sendo",
          "eles": "estarão sendo"
        },
        "presentSubjunctive": {
          "eu": "seja",
          "tu": "sejas",
          "você": "seja",
          "nós": "sejamos",
          "eles": "sejam"
        },
        "imperfectSubjunctive": {
          "eu": "fosse",
          "tu": "fosses",
          "você": "fosse",
          "nós": "fôssemos",
          "eles": "fossem"
        },
        "futureSubjunctive": {
          "eu": "for",
          "tu": "fores",
          "você": "for",
          "nós": "formos",
          "eles": "forem"
        },
        "imperativeAffirmative": {
          "tu": "sê",
          "você": "seja",
          "nós": "sejamos",
          "eles": "sejam"
        },
        "imperativeNegative": {
          "tu": "não sejas",
          "você": "não seja",
          "nós": "não sejamos",
          "eles": "não sejam"
        }
      },
      "templates": [
        {
          "id": "ser-1",
          "complementType": "fixed",
          "fixedComplement": "estudante",
          "englishVerb": "be",
          "englishTranslationPattern": "{pronoun} {verb} a student",
          "englishTranslationPatternPlural": "{pronoun} {verb} students",
          "allowedPhrases": [
            "time"
          ],
          "fixedComplementPlural": "estudantes"
        }
      ]
    },
    {
      "infinitive": "estar",
      "englishMeaning": "to be",
      "verbType": "irregular",
      "stemChangePattern": null,
      "conjugations": {
        "present": {
          "eu": "estou",
          "tu": "estás",
          "você": "está",
          "nós": "estamos",
          "eles": "estão"
        },
        "preterite": {
          "eu": "estive",
          "tu": "estiveste",
          "você": "esteve",
          "nós": "estivemos",
          "eles": "estiveram"
        },
        "imperfect": {
          "eu": "estava",
          "tu": "estavas",
          "você": "estava",
          "nós": "estávamos",
          "eles": "estavam"
        },
        "future": {
          "eu": "estarei",
          "tu": "estarás",
          "você": "estará",
          "nós": "estaremos",
          "eles": "estarão"
        },
        "conditional": {
          "eu": "estaria",
          "tu": "estarias",
          "você": "estaria",
          "nós": "estaríamos",
          "eles": "estariam"
        },
        "futureProgressive": {
          "eu": "estarei estando",
          "tu": "estarás estando",
          "você": "estará estando",
          "nós": "estaremos estando",
          "eles": "estarão estando"
        },
        "presentSubjunctive": {
          "eu": "esteja",
          "tu": "estejas",
          "você": "esteja",
          "nós": "estejamos",
          "eles": "estejam"
        },
        "imperfectSubjunctive": {
          "eu": "estivesse",
          "tu": "estivesses",
          "você": "estivesse",
          "nós": "estivéssemos",
          "eles": "estivessem"
        },
        "futureSubjunctive": {
          "eu": "estiver",
          "tu": "estiveres",
          "você": "estiver",
          "nós": "estivermos",
          "eles": "estiverem"
        },
        "imperativeAffirmative": {
          "tu": "está",
          "você": "esteja",
          "nós": "estejamos",
          "eles": "estejam"
        },
        "imperativeNegative": {
          "tu": "não estejas",
          "você": "não esteja",
          "nós": "não estejamos",
          "eles": "não estejam"
        }
      },
      "templates": [
        {
          "id": "estar-1",
          "complementType": "fixed",
          "fixedComplement": "cansado",
          "englishVerb": "be",
          "englishTranslationPattern": "{pronoun} {verb} tired",
          "allowedPhrases": [
            "time",
            "location"
          ],
          "fixedComplementFeminine": "cansada",
          "fixedComplementPlural": "cansados",
          "fixedComplementPluralFeminine": "cansadas"
        }
      ]
    },
    {
      "infinitive": "ter",
      "englishMeaning": "to have",
      "verbType": "irregular",
      "stemChangePattern": null,
      "conjugations": {
        "present": {
          "eu": "tenho",
          "tu": "tens",
          "você": "tem",
          "nós": "temos",
          "eles": "têm"
        },
        "preterite": {
          "eu": "tive",
          "tu": "tiveste",
          "você": "teve",
          "nós": "tivemos",
          "eles": "tiveram"
        },
        "imperfect": {
          "eu": "tinha",
          "tu": "tinhas",
          "você": "tinha",
          "nós": "tínhamos",
          "eles": "tinham"
        },
        "future": {
          "eu": "terei",
          "tu": "terás",
          "você": "terá",
          "nós": "teremos",
          "eles": "terão"
        },
        "conditional": {
          "eu": "teria",
          "tu": "terias",
          "você": "teria",
          "nós": "teríamos",
          "eles": "teriam"
        },
        "futureProgressive": {
          "eu": "estarei tendo",
          "tu": "estarás tendo",
          "você": "estará tendo",
          "nós": "estaremos tendo",
          "eles": "estarão tendo"
        },
        "presentSubjunctive": {
          "eu": "tenha",
          "tu": "tenhas",
          "você": "tenha",
          "nós": "tenhamos",
          "eles": "tenham"
        },
        "imperfectSubjunctive": {
          "eu": "tivesse",
          "tu": "tivesses",
          "você": "tivesse",
          "nós": "tivéssemos",
          "eles": "tivessem"
        },
        "futureSubjunctive": {
          "eu": "tiver",
          "tu": "tiveres",
          "você": "tiver",
          "nós": "tivermos",
          "eles": "tiverem"
        },
        "imperativeAffirmative": {
          "tu": "tem",
          "você": "tenha",
          "nós": "tenhamos",
          "eles": "tenham"
        },
        "imperativeNegative": {
          "tu": "não tenhas",
          "você": "não tenha",
          "nós": "não tenhamos",
          "eles": "não tenham"
        }
      },
      "templates": [
        {
          "id": "ter-1",
          "complementType": "fixed",
          "fixedComplement": "tempo",
          "englishVerb": "have",
          "englishTranslationPattern": "{pronoun} {verb} time",
          "allowedPhrases": [
            "time",
            "location"
          ]
        },
        {
          "id": "ter-2",
          "complementType": "objectSlot",
          "fixedComplement": null,
          "englishVerb": "have",
          "englishTranslationPattern": "{pronoun} {verb} {object}"
        },
        {
          "id": "ter-3",
          "complementType": "fixed",
          "fixedComplement": "vinte e nove anos",
          "englishVerb": "be",
          "englishTranslationPattern": "{pronoun} {verb} twenty-nine years old",
          "allowedPhrases": []
        }
      ]
    },
    {
      "infinitive": "ir",
      "englishMeaning": "to go",
      "verbType": "irregular",
      "stemChangePattern": null,
      "conjugations": {
        "present": {
          "eu": "vou",
          "tu": "vais",
          "você": "vai",
          "nós": "vamos",
          "eles": "vão"
        },
        "preterite": {
          "eu": "fui",
          "tu": "foste",
          "você": "foi",
          "nós": "fomos",
          "eles": "foram"
        },
        "imperfect": {
          "eu": "ia",
          "tu": "ias",
          "você": "ia",
          "nós": "íamos",
          "eles": "iam"
        },
        "future": {
          "eu": "irei",
          "tu": "irás",
          "você": "irá",
          "nós": "iremos",
          "eles": "irão"
        },
        "conditional": {
          "eu": "iria",
          "tu": "irias",
          "você": "iria",
          "nós": "iríamos",
          "eles": "iriam"
        },
        "futureProgressive": {
          "eu": "estarei indo",
          "tu": "estarás indo",
          "você": "estará indo",
          "nós": "estaremos indo",
          "eles": "estarão indo"
        },
        "presentSubjunctive": {
          "eu": "vá",
          "tu": "vás",
          "você": "vá",
          "nós": "vamos",
          "eles": "vão"
        },
        "imperfectSubjunctive": {
          "eu": "fosse",
          "tu": "fosses",
          "você": "fosse",
          "nós": "fôssemos",
          "eles": "fossem"
        },
        "futureSubjunctive": {
          "eu": "for",
          "tu": "fores",
          "você": "for",
          "nós": "formos",
          "eles": "forem"
        },
        "imperativeAffirmative": {
          "tu": "vai",
          "você": "vá",
          "nós": "vamos",
          "eles": "vão"
        },
        "imperativeNegative": {
          "tu": "não vás",
          "você": "não vá",
          "nós": "não vamos",
          "eles": "não vão"
        }
      },
      "templates": [
        {
          "id": "ir-1",
          "complementType": "fixed",
          "fixedComplement": "ao trabalho",
          "englishVerb": "go",
          "englishTranslationPattern": "{pronoun} {verb} to work",
          "allowedPhrases": [
            "time",
            "manner"
          ]
        },
        {
          "id": "ir-2",
          "complementType": "none",
          "fixedComplement": null,
          "englishVerb": "go",
          "englishTranslationPattern": "{pronoun} {verb}",
          "allowedPhrases": [
            "time",
            "manner"
          ]
        }
      ]
    },
    {
      "infinitive": "fazer",
      "englishMeaning": "to do",
      "verbType": "irregular",
      "stemChangePattern": null,
      "conjugations": {
        "present": {
          "eu": "faço",
          "tu": "fazes",
          "você": "faz",
          "nós": "fazemos",
          "eles": "fazem"
        },
        "preterite": {
          "eu": "fiz",
          "tu": "fizeste",
          "você": "fez",
          "nós": "fizemos",
          "eles": "fizeram"
        },
        "imperfect": {
          "eu": "fazia",
          "tu": "fazias",
          "você": "fazia",
          "nós": "fazíamos",
          "eles": "faziam"
        },
        "future": {
          "eu": "farei",
          "tu": "farás",
          "você": "fará",
          "nós": "faremos",
          "eles": "farão"
        },
        "conditional": {
          "eu": "faria",
          "tu": "farias",
          "você": "faria",
          "nós": "faríamos",
          "eles": "fariam"
        },
        "futureProgressive": {
          "eu": "estarei fazendo",
          "tu": "estarás fazendo",
          "você": "estará fazendo",
          "nós": "estaremos fazendo",
          "eles": "estarão fazendo"
        },
        "presentSubjunctive": {
          "eu": "faça",
          "tu": "faças",
          "você": "faça",
          "nós": "façamos",
          "eles": "façam"
        },
        "imperfectSubjunctive": {
          "eu": "fizesse",
          "tu": "fizesses",
          "você": "fizesse",
          "nós": "fizéssemos",
          "eles": "fizessem"
        },
        "futureSubjunctive": {
          "eu": "fizer",
          "tu": "fizeres",
          "você": "fizer",
          "nós": "fizermos",
          "eles": "fizerem"
        },
        "imperativeAffirmative": {
          "tu": "faz",
          "você": "faça",
          "nós": "façamos",
          "eles": "façam"
        },
        "imperativeNegative": {
          "tu": "não faças",
          "você": "não faça",
          "nós": "não façamos",
          "eles": "não façam"
        }
      },
      "templates": [
        {
          "id": "fazer-1",
          "complementType": "fixed",
          "fixedComplement": "o trabalho",
          "englishVerb": "do",
          "englishTranslationPattern": "{pronoun} {verb} the work"
        },
        {
          "id": "fazer-2",
          "complementType": "objectSlot",
          "fixedComplement": null,
          "englishVerb": "make",
          "englishTranslationPattern": "{pronoun} {verb} {object}"
        },
        {
          "id": "fazer-3",
          "complementType": "fixed",
          "fixedComplement": "trilha",
          "englishVerb": "go",
          "englishTranslationPattern": "{pronoun} {verb} hiking",
          "allowedPhrases": [
            "time"
          ]
        }
      ]
    },
    {
      "infinitive": "poder",
      "englishMeaning": "to be able to, can",
      "verbType": "irregular",
      "stemChangePattern": null,
      "conjugations": {
        "present": {
          "eu": "posso",
          "tu": "podes",
          "você": "pode",
          "nós": "podemos",
          "eles": "podem"
        },
        "preterite": {
          "eu": "pude",
          "tu": "pudeste",
          "você": "pôde",
          "nós": "pudemos",
          "eles": "puderam"
        },
        "imperfect": {
          "eu": "podia",
          "tu": "podias",
          "você": "podia",
          "nós": "podíamos",
          "eles": "podiam"
        },
        "future": {
          "eu": "poderei",
          "tu": "poderás",
          "você": "poderá",
          "nós": "poderemos",
          "eles": "poderão"
        },
        "conditional": {
          "eu": "poderia",
          "tu": "poderias",
          "você": "poderia",
          "nós": "poderíamos",
          "eles": "poderiam"
        },
        "futureProgressive": {
          "eu": "estarei podendo",
          "tu": "estarás podendo",
          "você": "estará podendo",
          "nós": "estaremos podendo",
          "eles": "estarão podendo"
        },
        "presentSubjunctive": {
          "eu": "possa",
          "tu": "possas",
          "você": "possa",
          "nós": "possamos",
          "eles": "possam"
        },
        "imperfectSubjunctive": {
          "eu": "pudesse",
          "tu": "pudesses",
          "você": "pudesse",
          "nós": "pudéssemos",
          "eles": "pudessem"
        },
        "futureSubjunctive": {
          "eu": "puder",
          "tu": "puderes",
          "você": "puder",
          "nós": "pudermos",
          "eles": "puderem"
        },
        "imperativeAffirmative": {
          "tu": "pode",
          "você": "possa",
          "nós": "possamos",
          "eles": "possam"
        },
        "imperativeNegative": {
          "tu": "não possas",
          "você": "não possa",
          "nós": "não possamos",
          "eles": "não possam"
        }
      },
      "templates": [
        {
          "id": "poder-1",
          "complementType": "objectSlot",
          "fixedComplement": null,
          "englishVerb": "can",
          "englishTranslationPattern": "{pronoun} {verb} {object}"
        }
      ]
    },
    {
      "infinitive": "dizer",
      "englishMeaning": "to say",
      "verbType": "irregular",
      "stemChangePattern": null,
      "conjugations": {
        "present": {
          "eu": "digo",
          "tu": "dizes",
          "você": "diz",
          "nós": "dizemos",
          "eles": "dizem"
        },
        "preterite": {
          "eu": "disse",
          "tu": "disseste",
          "você": "disse",
          "nós": "dissemos",
          "eles": "disseram"
        },
        "imperfect": {
          "eu": "dizia",
          "tu": "dizias",
          "você": "dizia",
          "nós": "dizíamos",
          "eles": "diziam"
        },
        "future": {
          "eu": "direi",
          "tu": "dirás",
          "você": "dirá",
          "nós": "diremos",
          "eles": "dirão"
        },
        "conditional": {
          "eu": "diria",
          "tu": "dirias",
          "você": "diria",
          "nós": "diríamos",
          "eles": "diriam"
        },
        "futureProgressive": {
          "eu": "estarei dizendo",
          "tu": "estarás dizendo",
          "você": "estará dizendo",
          "nós": "estaremos dizendo",
          "eles": "estarão dizendo"
        },
        "presentSubjunctive": {
          "eu": "diga",
          "tu": "digas",
          "você": "diga",
          "nós": "digamos",
          "eles": "digam"
        },
        "imperfectSubjunctive": {
          "eu": "dissesse",
          "tu": "dissesses",
          "você": "dissesse",
          "nós": "disséssemos",
          "eles": "dissessem"
        },
        "futureSubjunctive": {
          "eu": "disser",
          "tu": "disseres",
          "você": "disser",
          "nós": "dissermos",
          "eles": "disserem"
        },
        "imperativeAffirmative": {
          "tu": "diz",
          "você": "diga",
          "nós": "digamos",
          "eles": "digam"
        },
        "imperativeNegative": {
          "tu": "não digas",
          "você": "não diga",
          "nós": "não digamos",
          "eles": "não digam"
        }
      },
      "templates": [
        {
          "id": "dizer-1",
          "complementType": "fixed",
          "fixedComplement": "a verdade",
          "englishVerb": "say",
          "englishTranslationPattern": "{pronoun} {verb} the truth"
        },
        {
          "id": "dizer-2",
          "complementType": "objectSlot",
          "fixedComplement": null,
          "englishVerb": "say",
          "englishTranslationPattern": "{pronoun} {verb} {object}"
        }
      ]
    },
    {
      "infinitive": "trazer",
      "englishMeaning": "to bring",
      "verbType": "irregular",
      "stemChangePattern": null,
      "conjugations": {
        "present": {
          "eu": "trago",
          "tu": "trazes",
          "você": "traz",
          "nós": "trazemos",
          "eles": "trazem"
        },
        "preterite": {
          "eu": "trouxe",
          "tu": "trouxeste",
          "você": "trouxe",
          "nós": "trouxemos",
          "eles": "trouxeram"
        },
        "imperfect": {
          "eu": "trazia",
          "tu": "trazias",
          "você": "trazia",
          "nós": "trazíamos",
          "eles": "traziam"
        },
        "future": {
          "eu": "trarei",
          "tu": "trarás",
          "você": "trará",
          "nós": "traremos",
          "eles": "trarão"
        },
        "conditional": {
          "eu": "traria",
          "tu": "trarias",
          "você": "traria",
          "nós": "traríamos",
          "eles": "trariam"
        },
        "futureProgressive": {
          "eu": "estarei trazendo",
          "tu": "estarás trazendo",
          "você": "estará trazendo",
          "nós": "estaremos trazendo",
          "eles": "estarão trazendo"
        },
        "presentSubjunctive": {
          "eu": "traga",
          "tu": "tragas",
          "você": "traga",
          "nós": "tragamos",
          "eles": "tragam"
        },
        "imperfectSubjunctive": {
          "eu": "trouxesse",
          "tu": "trouxesses",
          "você": "trouxesse",
          "nós": "trouxéssemos",
          "eles": "trouxessem"
        },
        "futureSubjunctive": {
          "eu": "trouxer",
          "tu": "trouxeres",
          "você": "trouxer",
          "nós": "trouxermos",
          "eles": "trouxerem"
        },
        "imperativeAffirmative": {
          "tu": "traz",
          "você": "traga",
          "nós": "tragamos",
          "eles": "tragam"
        },
        "imperativeNegative": {
          "tu": "não tragas",
          "você": "não traga",
          "nós": "não tragamos",
          "eles": "não tragam"
        }
      },
      "templates": [
        {
          "id": "trazer-1",
          "complementType": "fixed",
          "fixedComplement": "o almoço",
          "englishVerb": "bring",
          "englishTranslationPattern": "{pronoun} {verb} lunch"
        },
        {
          "id": "trazer-2",
          "complementType": "objectSlot",
          "fixedComplement": null,
          "englishVerb": "bring",
          "englishTranslationPattern": "{pronoun} {verb} {object}"
        },
        {
          "id": "trazer-3",
          "complementType": "fixed",
          "fixedComplement": "o documento",
          "englishVerb": "bring",
          "englishTranslationPattern": "{pronoun} {verb} the document",
          "allowedPhrases": [
            "time"
          ]
        }
      ]
    },
    {
      "infinitive": "dar",
      "englishMeaning": "to give",
      "verbType": "irregular",
      "stemChangePattern": null,
      "conjugations": {
        "present": {
          "eu": "dou",
          "tu": "dás",
          "você": "dá",
          "nós": "damos",
          "eles": "dão"
        },
        "preterite": {
          "eu": "dei",
          "tu": "deste",
          "você": "deu",
          "nós": "demos",
          "eles": "deram"
        },
        "imperfect": {
          "eu": "dava",
          "tu": "davas",
          "você": "dava",
          "nós": "dávamos",
          "eles": "davam"
        },
        "future": {
          "eu": "darei",
          "tu": "darás",
          "você": "dará",
          "nós": "daremos",
          "eles": "darão"
        },
        "conditional": {
          "eu": "daria",
          "tu": "darias",
          "você": "daria",
          "nós": "daríamos",
          "eles": "dariam"
        },
        "futureProgressive": {
          "eu": "estarei dando",
          "tu": "estarás dando",
          "você": "estará dando",
          "nós": "estaremos dando",
          "eles": "estarão dando"
        },
        "presentSubjunctive": {
          "eu": "dê",
          "tu": "dês",
          "você": "dê",
          "nós": "demos",
          "eles": "deem"
        },
        "imperfectSubjunctive": {
          "eu": "desse",
          "tu": "desses",
          "você": "desse",
          "nós": "déssemos",
          "eles": "dessem"
        },
        "futureSubjunctive": {
          "eu": "der",
          "tu": "deres",
          "você": "der",
          "nós": "dermos",
          "eles": "derem"
        },
        "imperativeAffirmative": {
          "tu": "dá",
          "você": "dê",
          "nós": "demos",
          "eles": "deem"
        },
        "imperativeNegative": {
          "tu": "não dês",
          "você": "não dê",
          "nós": "não demos",
          "eles": "não deem"
        }
      },
      "templates": [
        {
          "id": "dar-1",
          "complementType": "fixed",
          "fixedComplement": "um presente",
          "englishVerb": "give",
          "englishTranslationPattern": "{pronoun} {verb} a gift"
        },
        {
          "id": "dar-2",
          "complementType": "objectSlot",
          "fixedComplement": null,
          "englishVerb": "give",
          "englishTranslationPattern": "{pronoun} {verb} {object}"
        }
      ]
    },
    {
      "infinitive": "ver",
      "englishMeaning": "to see",
      "verbType": "irregular",
      "stemChangePattern": null,
      "conjugations": {
        "present": {
          "eu": "vejo",
          "tu": "vês",
          "você": "vê",
          "nós": "vemos",
          "eles": "veem"
        },
        "preterite": {
          "eu": "vi",
          "tu": "viste",
          "você": "viu",
          "nós": "vimos",
          "eles": "viram"
        },
        "imperfect": {
          "eu": "via",
          "tu": "vias",
          "você": "via",
          "nós": "víamos",
          "eles": "viam"
        },
        "future": {
          "eu": "verei",
          "tu": "verás",
          "você": "verá",
          "nós": "veremos",
          "eles": "verão"
        },
        "conditional": {
          "eu": "veria",
          "tu": "verias",
          "você": "veria",
          "nós": "veríamos",
          "eles": "veriam"
        },
        "futureProgressive": {
          "eu": "estarei vendo",
          "tu": "estarás vendo",
          "você": "estará vendo",
          "nós": "estaremos vendo",
          "eles": "estarão vendo"
        },
        "presentSubjunctive": {
          "eu": "veja",
          "tu": "vejas",
          "você": "veja",
          "nós": "vejamos",
          "eles": "vejam"
        },
        "imperfectSubjunctive": {
          "eu": "visse",
          "tu": "visses",
          "você": "visse",
          "nós": "víssemos",
          "eles": "vissem"
        },
        "futureSubjunctive": {
          "eu": "vir",
          "tu": "vires",
          "você": "vir",
          "nós": "virmos",
          "eles": "virem"
        },
        "imperativeAffirmative": {
          "tu": "vê",
          "você": "veja",
          "nós": "vejamos",
          "eles": "vejam"
        },
        "imperativeNegative": {
          "tu": "não vejas",
          "você": "não veja",
          "nós": "não vejamos",
          "eles": "não vejam"
        }
      },
      "templates": [
        {
          "id": "ver-1",
          "complementType": "fixed",
          "fixedComplement": "o filme",
          "englishVerb": "see",
          "englishTranslationPattern": "{pronoun} {verb} the movie"
        },
        {
          "id": "ver-2",
          "complementType": "objectSlot",
          "fixedComplement": null,
          "englishVerb": "see",
          "englishTranslationPattern": "{pronoun} {verb} {object}"
        }
      ]
    },
    {
      "infinitive": "saber",
      "englishMeaning": "to know",
      "verbType": "irregular",
      "stemChangePattern": null,
      "conjugations": {
        "present": {
          "eu": "sei",
          "tu": "sabes",
          "você": "sabe",
          "nós": "sabemos",
          "eles": "sabem"
        },
        "preterite": {
          "eu": "soube",
          "tu": "soubeste",
          "você": "soube",
          "nós": "soubemos",
          "eles": "souberam"
        },
        "imperfect": {
          "eu": "sabia",
          "tu": "sabias",
          "você": "sabia",
          "nós": "sabíamos",
          "eles": "sabiam"
        },
        "future": {
          "eu": "saberei",
          "tu": "saberás",
          "você": "saberá",
          "nós": "saberemos",
          "eles": "saberão"
        },
        "conditional": {
          "eu": "saberia",
          "tu": "saberias",
          "você": "saberia",
          "nós": "saberíamos",
          "eles": "saberiam"
        },
        "futureProgressive": {
          "eu": "estarei sabendo",
          "tu": "estarás sabendo",
          "você": "estará sabendo",
          "nós": "estaremos sabendo",
          "eles": "estarão sabendo"
        },
        "presentSubjunctive": {
          "eu": "saiba",
          "tu": "saibas",
          "você": "saiba",
          "nós": "saibamos",
          "eles": "saibam"
        },
        "imperfectSubjunctive": {
          "eu": "soubesse",
          "tu": "soubesses",
          "você": "soubesse",
          "nós": "soubéssemos",
          "eles": "soubessem"
        },
        "futureSubjunctive": {
          "eu": "souber",
          "tu": "souberes",
          "você": "souber",
          "nós": "soubermos",
          "eles": "souberem"
        },
        "imperativeAffirmative": {
          "tu": "sabe",
          "você": "saiba",
          "nós": "saibamos",
          "eles": "saibam"
        },
        "imperativeNegative": {
          "tu": "não saibas",
          "você": "não saiba",
          "nós": "não saibamos",
          "eles": "não saibam"
        }
      },
      "templates": [
        {
          "id": "saber-1",
          "complementType": "fixed",
          "fixedComplement": "a resposta",
          "englishVerb": "know",
          "englishTranslationPattern": "{pronoun} {verb} the answer",
          "allowedPhrases": [
            "time",
            "location"
          ]
        },
        {
          "id": "saber-2",
          "complementType": "objectSlot",
          "fixedComplement": null,
          "englishVerb": "know",
          "englishTranslationPattern": "{pronoun} {verb} {object}"
        }
      ]
    },
    {
      "infinitive": "querer",
      "englishMeaning": "to want",
      "verbType": "irregular",
      "stemChangePattern": null,
      "conjugations": {
        "present": {
          "eu": "quero",
          "tu": "queres",
          "você": "quer",
          "nós": "queremos",
          "eles": "querem"
        },
        "preterite": {
          "eu": "quis",
          "tu": "quiseste",
          "você": "quis",
          "nós": "quisemos",
          "eles": "quiseram"
        },
        "imperfect": {
          "eu": "queria",
          "tu": "querias",
          "você": "queria",
          "nós": "queríamos",
          "eles": "queriam"
        },
        "future": {
          "eu": "quererei",
          "tu": "quererás",
          "você": "quererá",
          "nós": "quereremos",
          "eles": "quererão"
        },
        "conditional": {
          "eu": "quereria",
          "tu": "quererias",
          "você": "quereria",
          "nós": "quereríamos",
          "eles": "quereriam"
        },
        "futureProgressive": {
          "eu": "estarei querendo",
          "tu": "estarás querendo",
          "você": "estará querendo",
          "nós": "estaremos querendo",
          "eles": "estarão querendo"
        },
        "presentSubjunctive": {
          "eu": "queira",
          "tu": "queiras",
          "você": "queira",
          "nós": "queiramos",
          "eles": "queiram"
        },
        "imperfectSubjunctive": {
          "eu": "quisesse",
          "tu": "quisesses",
          "você": "quisesse",
          "nós": "quiséssemos",
          "eles": "quisessem"
        },
        "futureSubjunctive": {
          "eu": "quiser",
          "tu": "quiseres",
          "você": "quiser",
          "nós": "quisermos",
          "eles": "quiserem"
        },
        "imperativeAffirmative": {
          "tu": "quer",
          "você": "queira",
          "nós": "queiramos",
          "eles": "queiram"
        },
        "imperativeNegative": {
          "tu": "não queiras",
          "você": "não queira",
          "nós": "não queiramos",
          "eles": "não queiram"
        }
      },
      "templates": [
        {
          "id": "querer-1",
          "complementType": "fixed",
          "fixedComplement": "café",
          "englishVerb": "want",
          "englishTranslationPattern": "{pronoun} {verb} coffee",
          "allowedPhrases": [
            "time",
            "location"
          ]
        },
        {
          "id": "querer-2",
          "complementType": "objectSlot",
          "fixedComplement": null,
          "englishVerb": "want",
          "englishTranslationPattern": "{pronoun} {verb} {object}"
        }
      ]
    },
    {
      "infinitive": "vir",
      "englishMeaning": "to come",
      "verbType": "irregular",
      "stemChangePattern": null,
      "conjugations": {
        "present": {
          "eu": "venho",
          "tu": "vens",
          "você": "vem",
          "nós": "vimos",
          "eles": "vêm"
        },
        "preterite": {
          "eu": "vim",
          "tu": "vieste",
          "você": "veio",
          "nós": "viemos",
          "eles": "vieram"
        },
        "imperfect": {
          "eu": "vinha",
          "tu": "vinhas",
          "você": "vinha",
          "nós": "vínhamos",
          "eles": "vinham"
        },
        "future": {
          "eu": "virei",
          "tu": "virás",
          "você": "virá",
          "nós": "viremos",
          "eles": "virão"
        },
        "conditional": {
          "eu": "viria",
          "tu": "virias",
          "você": "viria",
          "nós": "viríamos",
          "eles": "viriam"
        },
        "futureProgressive": {
          "eu": "estarei vindo",
          "tu": "estarás vindo",
          "você": "estará vindo",
          "nós": "estaremos vindo",
          "eles": "estarão vindo"
        },
        "presentSubjunctive": {
          "eu": "venha",
          "tu": "venhas",
          "você": "venha",
          "nós": "venhamos",
          "eles": "venham"
        },
        "imperfectSubjunctive": {
          "eu": "viesse",
          "tu": "viesses",
          "você": "viesse",
          "nós": "viéssemos",
          "eles": "viessem"
        },
        "futureSubjunctive": {
          "eu": "vier",
          "tu": "vieres",
          "você": "vier",
          "nós": "viermos",
          "eles": "vierem"
        },
        "imperativeAffirmative": {
          "tu": "vem",
          "você": "venha",
          "nós": "venhamos",
          "eles": "venham"
        },
        "imperativeNegative": {
          "tu": "não venhas",
          "você": "não venha",
          "nós": "não venhamos",
          "eles": "não venham"
        }
      },
      "templates": [
        {
          "id": "vir-1",
          "complementType": "fixed",
          "fixedComplement": "de ônibus",
          "englishVerb": "come",
          "englishTranslationPattern": "{pronoun} {verb} by bus",
          "allowedPhrases": [
            "time",
            "manner"
          ]
        },
        {
          "id": "vir-2",
          "complementType": "none",
          "fixedComplement": null,
          "englishVerb": "come",
          "englishTranslationPattern": "{pronoun} {verb}",
          "allowedPhrases": [
            "time",
            "manner"
          ]
        }
      ]
    },
    {
      "infinitive": "ficar",
      "englishMeaning": "to stay, to become",
      "verbType": "regular-ar",
      "stemChangePattern": null,
      "conjugations": {
        "present": {
          "eu": "fico",
          "tu": "ficas",
          "você": "fica",
          "nós": "ficamos",
          "eles": "ficam"
        },
        "preterite": {
          "eu": "fiquei",
          "tu": "ficaste",
          "você": "ficou",
          "nós": "ficamos",
          "eles": "ficaram"
        },
        "imperfect": {
          "eu": "ficava",
          "tu": "ficavas",
          "você": "ficava",
          "nós": "ficávamos",
          "eles": "ficavam"
        },
        "future": {
          "eu": "ficarei",
          "tu": "ficarás",
          "você": "ficará",
          "nós": "ficaremos",
          "eles": "ficarão"
        },
        "conditional": {
          "eu": "ficaria",
          "tu": "ficarias",
          "você": "ficaria",
          "nós": "ficaríamos",
          "eles": "ficariam"
        },
        "futureProgressive": {
          "eu": "estarei ficando",
          "tu": "estarás ficando",
          "você": "estará ficando",
          "nós": "estaremos ficando",
          "eles": "estarão ficando"
        },
        "presentSubjunctive": {
          "eu": "fique",
          "tu": "fiques",
          "você": "fique",
          "nós": "fiquemos",
          "eles": "fiquem"
        },
        "imperfectSubjunctive": {
          "eu": "ficasse",
          "tu": "ficasses",
          "você": "ficasse",
          "nós": "ficássemos",
          "eles": "ficassem"
        },
        "futureSubjunctive": {
          "eu": "ficar",
          "tu": "ficares",
          "você": "ficar",
          "nós": "ficarmos",
          "eles": "ficarem"
        },
        "imperativeAffirmative": {
          "tu": "fica",
          "você": "fique",
          "nós": "fiquemos",
          "eles": "fiquem"
        },
        "imperativeNegative": {
          "tu": "não fiques",
          "você": "não fique",
          "nós": "não fiquemos",
          "eles": "não fiquem"
        }
      },
      "templates": [
        {
          "id": "ficar-1",
          "complementType": "fixed",
          "fixedComplement": "em casa",
          "englishVerb": "stay",
          "englishTranslationPattern": "{pronoun} {verb} home",
          "allowedPhrases": [
            "time"
          ]
        },
        {
          "id": "ficar-2",
          "complementType": "fixed",
          "fixedComplement": "feliz",
          "englishVerb": "get",
          "englishTranslationPattern": "{pronoun} {verb} happy",
          "allowedPhrases": [
            "time",
            "location"
          ],
          "fixedComplementPlural": "felizes"
        }
      ]
    },
    {
      "infinitive": "ouvir",
      "englishMeaning": "to hear",
      "verbType": "irregular",
      "stemChangePattern": null,
      "conjugations": {
        "present": {
          "eu": "ouço",
          "tu": "ouves",
          "você": "ouve",
          "nós": "ouvimos",
          "eles": "ouvem"
        },
        "preterite": {
          "eu": "ouvi",
          "tu": "ouviste",
          "você": "ouviu",
          "nós": "ouvimos",
          "eles": "ouviram"
        },
        "imperfect": {
          "eu": "ouvia",
          "tu": "ouvias",
          "você": "ouvia",
          "nós": "ouvíamos",
          "eles": "ouviam"
        },
        "future": {
          "eu": "ouvirei",
          "tu": "ouvirás",
          "você": "ouvirá",
          "nós": "ouviremos",
          "eles": "ouvirão"
        },
        "conditional": {
          "eu": "ouviria",
          "tu": "ouvirias",
          "você": "ouviria",
          "nós": "ouviríamos",
          "eles": "ouviriam"
        },
        "futureProgressive": {
          "eu": "estarei ouvindo",
          "tu": "estarás ouvindo",
          "você": "estará ouvindo",
          "nós": "estaremos ouvindo",
          "eles": "estarão ouvindo"
        },
        "presentSubjunctive": {
          "eu": "ouça",
          "tu": "ouças",
          "você": "ouça",
          "nós": "ouçamos",
          "eles": "ouçam"
        },
        "imperfectSubjunctive": {
          "eu": "ouvisse",
          "tu": "ouvisses",
          "você": "ouvisse",
          "nós": "ouvíssemos",
          "eles": "ouvissem"
        },
        "futureSubjunctive": {
          "eu": "ouvir",
          "tu": "ouvires",
          "você": "ouvir",
          "nós": "ouvirmos",
          "eles": "ouvirem"
        },
        "imperativeAffirmative": {
          "tu": "ouve",
          "você": "ouça",
          "nós": "ouçamos",
          "eles": "ouçam"
        },
        "imperativeNegative": {
          "tu": "não ouças",
          "você": "não ouça",
          "nós": "não ouçamos",
          "eles": "não ouçam"
        }
      },
      "templates": [
        {
          "id": "ouvir-1",
          "complementType": "fixed",
          "fixedComplement": "música",
          "englishVerb": "listen to",
          "englishTranslationPattern": "{pronoun} {verb} music",
          "allowedPhrases": [
            "time",
            "location"
          ]
        },
        {
          "id": "ouvir-2",
          "complementType": "objectSlot",
          "fixedComplement": null,
          "englishVerb": "hear",
          "englishTranslationPattern": "{pronoun} {verb} {object}"
        }
      ]
    },
    {
      "infinitive": "entender",
      "englishMeaning": "to understand",
      "verbType": "regular-er",
      "stemChangePattern": null,
      "conjugations": {
        "present": {
          "eu": "entendo",
          "tu": "entendes",
          "você": "entende",
          "nós": "entendemos",
          "eles": "entendem"
        },
        "preterite": {
          "eu": "entendi",
          "tu": "entendeste",
          "você": "entendeu",
          "nós": "entendemos",
          "eles": "entenderam"
        },
        "imperfect": {
          "eu": "entendia",
          "tu": "entendias",
          "você": "entendia",
          "nós": "entendíamos",
          "eles": "entendiam"
        },
        "future": {
          "eu": "entenderei",
          "tu": "entenderás",
          "você": "entenderá",
          "nós": "entenderemos",
          "eles": "entenderão"
        },
        "conditional": {
          "eu": "entenderia",
          "tu": "entenderias",
          "você": "entenderia",
          "nós": "entenderíamos",
          "eles": "entenderiam"
        },
        "futureProgressive": {
          "eu": "estarei entendendo",
          "tu": "estarás entendendo",
          "você": "estará entendendo",
          "nós": "estaremos entendendo",
          "eles": "estarão entendendo"
        },
        "presentSubjunctive": {
          "eu": "entenda",
          "tu": "entendas",
          "você": "entenda",
          "nós": "entendamos",
          "eles": "entendam"
        },
        "imperfectSubjunctive": {
          "eu": "entendesse",
          "tu": "entendesses",
          "você": "entendesse",
          "nós": "entendêssemos",
          "eles": "entendessem"
        },
        "futureSubjunctive": {
          "eu": "entender",
          "tu": "entenderes",
          "você": "entender",
          "nós": "entendermos",
          "eles": "entenderem"
        },
        "imperativeAffirmative": {
          "tu": "entende",
          "você": "entenda",
          "nós": "entendamos",
          "eles": "entendam"
        },
        "imperativeNegative": {
          "tu": "não entendas",
          "você": "não entenda",
          "nós": "não entendamos",
          "eles": "não entendam"
        }
      },
      "templates": [
        {
          "id": "entender-1",
          "complementType": "fixed",
          "fixedComplement": "a explicação",
          "englishVerb": "understand",
          "englishTranslationPattern": "{pronoun} {verb} the explanation",
          "allowedPhrases": [
            "manner"
          ]
        },
        {
          "id": "entender-2",
          "complementType": "objectSlot",
          "fixedComplement": null,
          "englishVerb": "understand",
          "englishTranslationPattern": "{pronoun} {verb} {object}"
        }
      ]
    },
    {
      "infinitive": "dividir",
      "englishMeaning": "to split",
      "verbType": "regular-ir",
      "stemChangePattern": null,
      "conjugations": {
        "present": {
          "eu": "divido",
          "tu": "divides",
          "você": "divide",
          "nós": "dividimos",
          "eles": "dividem"
        },
        "preterite": {
          "eu": "dividi",
          "tu": "dividiste",
          "você": "dividiu",
          "nós": "dividimos",
          "eles": "dividiram"
        },
        "imperfect": {
          "eu": "dividia",
          "tu": "dividias",
          "você": "dividia",
          "nós": "dividíamos",
          "eles": "dividiam"
        },
        "future": {
          "eu": "dividirei",
          "tu": "dividirás",
          "você": "dividirá",
          "nós": "dividiremos",
          "eles": "dividirão"
        },
        "conditional": {
          "eu": "dividiria",
          "tu": "dividirias",
          "você": "dividiria",
          "nós": "dividiríamos",
          "eles": "dividiriam"
        },
        "futureProgressive": {
          "eu": "estarei dividindo",
          "tu": "estarás dividindo",
          "você": "estará dividindo",
          "nós": "estaremos dividindo",
          "eles": "estarão dividindo"
        },
        "presentSubjunctive": {
          "eu": "divida",
          "tu": "dividas",
          "você": "divida",
          "nós": "dividamos",
          "eles": "dividam"
        },
        "imperfectSubjunctive": {
          "eu": "dividisse",
          "tu": "dividisses",
          "você": "dividisse",
          "nós": "dividíssemos",
          "eles": "dividissem"
        },
        "futureSubjunctive": {
          "eu": "dividir",
          "tu": "dividires",
          "você": "dividir",
          "nós": "dividirmos",
          "eles": "dividirem"
        },
        "imperativeAffirmative": {
          "tu": "divide",
          "você": "divida",
          "nós": "dividamos",
          "eles": "dividam"
        },
        "imperativeNegative": {
          "tu": "não dividas",
          "você": "não divida",
          "nós": "não dividamos",
          "eles": "não dividam"
        }
      },
      "templates": [
        {
          "id": "dividir-1",
          "complementType": "fixed",
          "fixedComplement": "a conta",
          "englishVerb": "split",
          "englishTranslationPattern": "{pronoun} {verb} the bill",
          "allowedPhrases": [
            "time"
          ]
        },
        {
          "id": "dividir-2",
          "complementType": "objectSlot",
          "fixedComplement": null,
          "englishVerb": "divide",
          "englishTranslationPattern": "{pronoun} {verb} {object}"
        }
      ]
    },
    {
      "infinitive": "crescer",
      "englishMeaning": "to grow",
      "verbType": "stem-changing",
      "stemChangePattern": "c→ç",
      "conjugations": {
        "present": {
          "eu": "cresço",
          "tu": "cresces",
          "você": "cresce",
          "nós": "crescemos",
          "eles": "crescem"
        },
        "preterite": {
          "eu": "cresci",
          "tu": "cresceste",
          "você": "cresceu",
          "nós": "crescemos",
          "eles": "cresceram"
        },
        "imperfect": {
          "eu": "crescia",
          "tu": "crescias",
          "você": "crescia",
          "nós": "crescíamos",
          "eles": "cresciam"
        },
        "future": {
          "eu": "crescerei",
          "tu": "crescerás",
          "você": "crescerá",
          "nós": "cresceremos",
          "eles": "crescerão"
        },
        "conditional": {
          "eu": "cresceria",
          "tu": "crescerias",
          "você": "cresceria",
          "nós": "cresceríamos",
          "eles": "cresceriam"
        },
        "futureProgressive": {
          "eu": "estarei crescendo",
          "tu": "estarás crescendo",
          "você": "estará crescendo",
          "nós": "estaremos crescendo",
          "eles": "estarão crescendo"
        },
        "presentSubjunctive": {
          "eu": "cresça",
          "tu": "cresças",
          "você": "cresça",
          "nós": "cresçamos",
          "eles": "cresçam"
        },
        "imperfectSubjunctive": {
          "eu": "crescesse",
          "tu": "crescesses",
          "você": "crescesse",
          "nós": "crescêssemos",
          "eles": "crescessem"
        },
        "futureSubjunctive": {
          "eu": "crescer",
          "tu": "cresceres",
          "você": "crescer",
          "nós": "crescermos",
          "eles": "crescerem"
        },
        "imperativeAffirmative": {
          "tu": "cresce",
          "você": "cresça",
          "nós": "cresçamos",
          "eles": "cresçam"
        },
        "imperativeNegative": {
          "tu": "não cresças",
          "você": "não cresça",
          "nós": "não cresçamos",
          "eles": "não cresçam"
        }
      },
      "templates": [
        {
          "id": "crescer-1",
          "complementType": "fixed",
          "fixedComplement": "no interior",
          "englishVerb": "grow up",
          "englishTranslationPattern": "{pronoun} {verb} in the countryside",
          "allowedPhrases": []
        }
      ],
      "stemChange": {
        "from": "c",
        "to": "ç",
        "tenses": {
          "present": [
            "eu"
          ],
          "presentSubjunctive": [
            "eu",
            "tu",
            "você",
            "nós",
            "vós",
            "eles"
          ]
        }
      }
    },
    {
      "infinitive": "descrever",
      "englishMeaning": "to describe",
      "verbType": "regular-er",
      "stemChangePattern": null,
      "conjugations": {
        "present": {
          "eu": "descrevo",
          "tu": "descreves",
          "você": "descreve",
          "nós": "descrevemos",
          "eles": "descrevem"
        },
        "preterite": {
          "eu": "descrevi",
          "tu": "descreveste",
          "você": "descreveu",
          "nós": "descrevemos",
          "eles": "descreveram"
        },
        "imperfect": {
          "eu": "descrevia",
          "tu": "descrevias",
          "você": "descrevia",
          "nós": "descrevíamos",
          "eles": "descreviam"
        },
        "future": {
          "eu": "descreverei",
          "tu": "descreverás",
          "você": "descreverá",
          "nós": "descreveremos",
          "eles": "descreverão"
        },
        "conditional": {
          "eu": "descreveria",
          "tu": "descreverias",
          "você": "descreveria",
          "nós": "descreveríamos",
          "eles": "descreveriam"
        },
        "futureProgressive": {
          "eu": "estarei descrevendo",
          "tu": "estarás descrevendo",
          "você": "estará descrevendo",
          "nós": "estaremos descrevendo",
          "eles": "estarão descrevendo"
        },
        "presentSubjunctive": {
          "eu": "descreva",
          "tu": "descrevas",
          "você": "descreva",
          "nós": "descrevamos",
          "eles": "descrevam"
        },
        "imperfectSubjunctive": {
          "eu": "descrevesse",
          "tu": "descrevesses",
          "você": "descrevesse",
          "nós": "descrevêssemos",
          "eles": "descrevessem"
        },
        "futureSubjunctive": {
          "eu": "descrever",
          "tu": "descreveres",
          "você": "descrever",
          "nós": "descrevermos",
          "eles": "descreverem"
        },
        "imperativeAffirmative": {
          "tu": "descreve",
          "você": "descreva",
          "nós": "descrevamos",
          "eles": "descrevam"
        },
        "imperativeNegative": {
          "tu": "não descrevas",
          "você": "não descreva",
          "nós": "não descrevamos",
          "eles": "não descrevam"
        }
      },
      "templates": [
        {
          "id": "descrever-1",
          "complementType": "fixed",
          "fixedComplement": "o clima",
          "englishVerb": "describe",
          "englishTranslationPattern": "{pronoun} {verb} the weather",
          "allowedPhrases": [
            "time"
          ]
        },
        {
          "id": "descrever-2",
          "complementType": "objectSlot",
          "fixedComplement": null,
          "englishVerb": "describe",
          "englishTranslationPattern": "{pronoun} {verb} {object}"
        }
      ]
    }
  ]
}
